import React, { useState, useEffect, useRef, useMemo } from 'react';
import { 
  Button, 
  TextField, 
  Grid, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Checkbox, 
  Paper, 
  TableFooter, 
  TablePagination, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  FormControlLabel, 
  Typography, 
  Modal, 
  Chip, 
  Tooltip, 
  IconButton, 
  Menu, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  Select, 
  CircularProgress,
  Card,
  CardContent,
  Alert,
  AlertTitle,
  Divider,
  Autocomplete
} from '@mui/material';
import {
  Add as AddIcon,
  Print as PrintIcon,
  Search as SearchIcon,
  Save as SaveIcon,
  Clear as ClearIcon,
  QrCodeScanner as ScanIcon,
  Visibility as ViewIcon,
  History as HistoryIcon,
  Settings as SettingsIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CompleteIcon,
  Close as CloseIcon,
  MeetingRoom as CubiculoIcon,
  WarningAmber as WarningIcon,
  HourglassEmpty as PendingIcon,
  PlayArrow as StartIcon,
  LocalHospital as ReceivedIcon,
  Science as AnalysisIcon,
  Cancel as CancelIcon,
  MoreVert as MoreVertIcon,
  ExpandLess as ExpandLessIcon,
  PersonOff as PacienteAusenteIcon,
  Comment as CommentIcon,
  CommentOutlined as CommentOutlinedIcon,
  Error as MuestraNoConformeIcon,
  Store as RecepcionVentanillaIcon,
  CameraAlt as CameraAltIcon,
  Stop as StopIcon,
  CheckCircle,
  Info as InfoIcon
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useSucursal } from '../contexts/SucursalContext';
import { useAccesos } from '../contexts/AccesosContext';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';

// Componente para el menÃº desplegable de acciones (versiÃ³n completa de TomaMuestra)
const AccionesDropdown = ({ 
  estadoActual, 
  estadosDisponibles, 
  onCambiarEstado, 
  getSiguienteEstado, 
  getEstadoIcon, 
  getEstadoButtonColor,
  isLoading = false,
  puedeReactivarMuestraNoConforme = true,
  enModalDetalle = false,
  disabled = false 
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEstadoClick = (estadoId) => {
    onCambiarEstado(estadoId);
    handleClose();
  };

  const estadoActualObj = estadosDisponibles.find(e => e.id === estadoActual);
  
  // Obtener opciones disponibles segÃºn el estado actual (LÃ“GICA COMPLETA DE TOMAMMUESTRA)
  const getOpcionesDisponibles = () => {
    if (!estadosDisponibles || estadosDisponibles.length === 0) return [];
    
    const estadoActualObj = estadosDisponibles.find(e => e.id === estadoActual);
    if (!estadoActualObj) return [];
    
    console.log('DEBUG getOpcionesDisponibles:', {
      estadoActual,
      estadoActualObj,
      estado: estadoActualObj.estado,
      orden: estadoActualObj.orden
    });
    
    const ordenActual = estadoActualObj.orden;
    
    // Obtener el siguiente estado en la secuencia ordenada
    const siguienteEstado = estadosDisponibles
      .filter(e => e.orden === ordenActual + 1)
      .sort((a, b) => a.orden - b.orden)[0];
    
    const opciones = [];
    
    // Agregar el siguiente estado secuencial como opciÃ³n primaria (si existe)
    const esEstadoEspecial = estadoActualObj.estado === 'Muestra No conforme' || 
                           estadoActualObj.estado === 'Muestra No Conforme' ||
                           estadoActualObj.estado === 'Anulada' || 
                           estadoActualObj.estado === 'Paciente Ausente' ||
                           estadoActualObj.estado === 'Muestra Repetida' ||
                           estadoActualObj.estado === 'Análisis Reprocesado' ||
                           estadoActualObj.estado === 'Analisis Reprocesado';
                           
    if (siguienteEstado && !esEstadoEspecial) {
      // CASO ESPECIAL: Si estamos en "Toma Realizada" y el siguiente es "Traslado"
      const estadoTomaRealizadaOrden = estadosDisponibles.find(e => e.estado === 'Toma Realizada')?.orden;
      const estadoTrasladoOrden = estadosDisponibles.find(e => e.estado === 'Traslado')?.orden;
      const estadoVerificadaOrden = estadosDisponibles.find(e => e.estado === 'Verificada')?.orden;
      
      if (estadoActualObj.orden === estadoTomaRealizadaOrden && siguienteEstado.orden === estadoTrasladoOrden) {
        const estadoVerificada = estadosDisponibles.find(e => e.orden === estadoVerificadaOrden);
        if (estadoVerificada) {
          opciones.push({
            id: estadoVerificada.id,
            estado: 'TRASLADAR/VERIFICAR',
            isPrimary: true,
            esCambioDoble: true,
            estadoIntermedio: siguienteEstado.id
          });
        }
        opciones.push({
          id: siguienteEstado.id,
          estado: siguienteEstado.estado,
          isPrimary: false
        });
      } else {
        opciones.push({
          id: siguienteEstado.id,
          estado: siguienteEstado.estado,
          isPrimary: true
        });
      }
    }
    
    // Agregar opciones especiales
    const estadoAnulada = estadosDisponibles.find(e => e.estado === 'Anulada');
    const estadoPacienteAusente = estadosDisponibles.find(e => e.estado === 'Paciente Ausente');
    const estadoRecepcionVentanilla = estadosDisponibles.find(e => e.estado === 'Recepción ventanilla');
    const estadoMuestraNoConforme = estadosDisponibles.find(e => 
      e.estado === 'Muestra No Conforme' || e.estado === 'Muestra No conforme'
    );
    const estadoPendiente = estadosDisponibles.find(e => e.estado === 'Pendiente');
    
    // En modal de detalle, agregar opciones de retroceso
    if (enModalDetalle) {
      const estadoAnterior = estadosDisponibles
        .filter(e => e.orden === ordenActual - 1)
        .sort((a, b) => a.orden - b.orden)[0];
      
      if (estadoAnterior && estadoAnterior.id !== estadoActual && estadoAnterior.estado !== 'Pendiente') {
        opciones.push({
          id: estadoAnterior.id,
          estado: `Volver a ${estadoAnterior.estado}`,
          isPrimary: false
        });
      }
      
      if (estadoPendiente && estadoActualObj.estado !== 'Pendiente') {
        opciones.push({
          id: estadoPendiente.id,
          estado: 'Volver a Pendiente',
          isPrimary: false
        });
      }
    }
    
    // Solo agregar "Anular" si no estamos en un estado final
    if (estadoAnulada && estadoActualObj.estado !== 'Anulada' && estadoActualObj.estado !== 'Procesada') {
      opciones.push({
        id: estadoAnulada.id,
        estado: estadoAnulada.estado,
        isPrimary: false
      });
    }
    
    // Solo agregar "Paciente Ausente" desde Pendiente
    if (estadoActualObj.estado === 'Pendiente' && estadoPacienteAusente) {
      opciones.push({
        id: estadoPacienteAusente.id,
        estado: estadoPacienteAusente.estado,
        isPrimary: false
      });
    }
    
    // Solo agregar "Recepción ventanilla" desde Pendiente
    if (estadoActualObj.estado === 'Pendiente' && estadoRecepcionVentanilla) {
      opciones.push({
        id: estadoRecepcionVentanilla.id,
        estado: estadoRecepcionVentanilla.estado,
        isPrimary: false
      });
    }
    
    // Muestra No Conforme disponible en varios estados
    if (estadoMuestraNoConforme && 
        !['Muestra No conforme', 'Muestra No Conforme', 'Anulada', 'Procesada', 'Muestra Repetida', 'Análisis Reprocesado', 'Analisis Reprocesado'].includes(estadoActualObj.estado)) {
      opciones.push({
        id: estadoMuestraNoConforme.id,
        estado: estadoMuestraNoConforme.estado,
        isPrimary: false
      });
    }
    
    // Muestra Repetida disponible solo desde Verificada (orden >= 5) en adelante
    const estadoMuestraRepetida = estadosDisponibles.find(e => e.estado === 'Muestra Repetida');
    const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
    const ordenVerificada = estadoVerificada ? estadoVerificada.orden : 5;
    if (estadoMuestraRepetida && 
        ordenActual >= ordenVerificada &&
        !['Muestra No conforme', 'Muestra No Conforme', 'Anulada', 'Procesada', 'Muestra Repetida', 'Análisis Reprocesado', 'Analisis Reprocesado'].includes(estadoActualObj.estado)) {
      opciones.push({
        id: estadoMuestraRepetida.id,
        estado: estadoMuestraRepetida.estado,
        isPrimary: false
      });
    }
    
    // Desde Muestra Repetida, permitir volver a Pendiente
    if (estadoActualObj.estado === 'Muestra Repetida' && estadoPendiente) {
      opciones.push({
        id: estadoPendiente.id,
        estado: 'Reactivar a Pendiente',
        isPrimary: true
      });
    }
    
    // Análisis Reprocesado: auto-transición (reprocesar de nuevo)
    const estadoReprocesado = estadosDisponibles.find(e => e.estado === 'Análisis Reprocesado' || e.estado === 'Analisis Reprocesado');
    if (estadoReprocesado && (estadoActualObj.estado === 'Análisis Reprocesado' || estadoActualObj.estado === 'Analisis Reprocesado')) {
      opciones.push({
        id: estadoReprocesado.id,
        estado: 'Reprocesar nuevamente',
        isPrimary: true
      });
    }
    
    // Desde Muestra No Conforme, permitir reactivaciÃ³n solo si estÃ¡ configurado
    const desdeMuestraNoConforme = estadoActualObj.estado === 'Muestra No Conforme' || 
                                   estadoActualObj.estado === 'Muestra No conforme';
    if (desdeMuestraNoConforme && puedeReactivarMuestraNoConforme && estadoPendiente) {
      opciones.push({
        id: estadoPendiente.id,
        estado: 'Reactivar a Pendiente',
        isPrimary: true
      });
    }
    
    // Desde Paciente Ausente, permitir continuar
    if (estadoActualObj.estado === 'Paciente Ausente' && siguienteEstado) {
      opciones.push({
        id: siguienteEstado.id,
        estado: `Continuar a ${siguienteEstado.estado}`,
        isPrimary: true
      });
    }
    
    // Desde RecepciÃ³n ventanilla, permitir continuar
    if (estadoActualObj.estado === 'Recepción ventanilla') {
      const estadoTraslado = estadosDisponibles.find(e => e.estado === 'Traslado');
      const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
      
      if (estadoTraslado && estadoVerificada) {
        // Agregar TRASLADAR/VERIFICAR como opciÃ³n primaria
        opciones.push({
          id: estadoVerificada.id,
          estado: 'TRASLADAR/VERIFICAR',
          isPrimary: true,
          esCambioDoble: true,
          estadoIntermedio: estadoTraslado.id
        });
        // Agregar TRASLADO normal como opciÃ³n secundaria
        opciones.push({
          id: estadoTraslado.id,
          estado: estadoTraslado.estado,
          isPrimary: false
        });
      } else if (estadoTraslado) {
        // Si no hay estado Verificada, solo mostrar Traslado
        opciones.push({
          id: estadoTraslado.id,
          estado: `Enviar a ${estadoTraslado.estado}`,
          isPrimary: true
        });
      }
    }
    
    // Desde "Verificada", permitir re-verificar con nuevos datos
    if (estadoActualObj.estado === 'Verificada') {
      const estadoTraslado = estadosDisponibles.find(e => e.estado === 'Traslado');
      const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
      
      if (estadoTraslado && estadoVerificada) {
        // Agregar RE-VERIFICAR como opciÃ³n primaria
        opciones.push({
          id: estadoVerificada.id,
          estado: 'RE-VERIFICAR',
          isPrimary: true,
          esCambioDoble: true,
          estadoIntermedio: estadoTraslado.id
        });
      }
    }
    
    return opciones;
  };

  const opcionesDisponibles = getOpcionesDisponibles();
  const opcionPrimaria = opcionesDisponibles.find(op => op.isPrimary);
  const opcionesSecundarias = opcionesDisponibles.filter(op => !op.isPrimary);

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      {opcionPrimaria ? (
        <Button
          size="small"
          variant="contained"
          color={getEstadoButtonColor(opcionPrimaria.id)}
          onClick={() => onCambiarEstado(opcionPrimaria.id)}
          startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : getEstadoIcon(opcionPrimaria.id)}
          disabled={isLoading || disabled}
          sx={{
            minWidth: '140px',
            fontSize: '0.8rem',
            padding: '6px 12px',
            fontWeight: 'bold',
            boxShadow: 2,
            opacity: isLoading ? 0.7 : 1,
            '&:hover': {
              boxShadow: isLoading ? 2 : 4,
              transform: isLoading ? 'none' : 'translateY(-1px)'
            },
            '& .MuiButton-startIcon': {
              fontSize: '1rem'
            }
          }}
        >
          {isLoading ? 'Guardando...' : opcionPrimaria.estado}
        </Button>
      ) : (
        <Chip 
          label="Estado Final" 
          color="success" 
          variant="outlined"
          icon={<CompleteIcon />}
        />
      )}

      {opcionesSecundarias.length > 0 && (
        <>
          <IconButton
            onClick={handleClick}
            size="small"
            disabled={isLoading || disabled}
            sx={{
              backgroundColor: '#f5f5f5',
              border: '1px solid #ddd',
              opacity: isLoading ? 0.5 : 1,
              '&:hover': {
                backgroundColor: isLoading ? '#f5f5f5' : '#e0e0e0'
              }
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
          
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            {opcionesSecundarias.map((opcion) => (
              <MenuItem 
                key={opcion.id} 
                onClick={() => handleEstadoClick(opcion.id)}
                sx={{ 
                  fontSize: '0.8rem',
                  color: opcion.id === 6 ? '#dc3545' : 'inherit'
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {getEstadoIcon(opcion.id)}
                  {opcion.estado}
                </Box>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
};

const TomaMuestraPorCodigo = () => {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;

  // Estados principales
  const [muestrasEscaneadas, setMuestrasEscaneadas] = useState([]);
  const [codigoBarra, setCodigoBarra] = useState('');
  const [scanning, setScanning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePage, setTablePage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Estados para etiquetas
  const [muestrasSeleccionadas, setMuestrasSeleccionadas] = useState([]);
  const [imprimirEtiquetasOpen, setImprimirEtiquetasOpen] = useState(false);
  const [openEtiquetasPreview, setOpenEtiquetasPreview] = useState(false);
  const [etiquetasPdfUrl, setEtiquetasPdfUrl] = useState(null);

  // Estados para gestión de cubí­culo
  const [cubiculoSeleccionado, setCubiculoSeleccionado] = useState('verificacion');
  const [modalCubiculoOpen, setModalCubiculoOpen] = useState(false);
  const [mostrarAlertaCubiculo, setMostrarAlertaCubiculo] = useState(false);
  
  // Estados para tracking de acciones
  const [accionesRealizadas, setAccionesRealizadas] = useState({
    muestrasModificadas: 0,
    etiquetasImpresas: 0,
    cambiosEstado: [],
    fechaInicio: new Date()
  });
  const [guardandoFormulario, setGuardandoFormulario] = useState(false);

  // Estados para condiciones (si aplica)
  const [condiciones, setCondiciones] = useState([]);
  const [estadosDisponibles, setEstadosDisponibles] = useState([]);
  
  // Estados para modal de detalle de muestras individuales
  const [modalDetalleOpen, setModalDetalleOpen] = useState(false);
  const [muestrasDetalle, setMuestrasDetalle] = useState([]);
  const [grupoSeleccionado, setGrupoSeleccionado] = useState(null);
  const [muestrasDetalleSeleccionadas, setMuestrasDetalleSeleccionadas] = useState([]);
  
  // Estados para modal de selección de módulo/muestra/análisis (nueva UI táctil)
  const [modalSeleccionAnalisisOpen, setModalSeleccionAnalisisOpen] = useState(false);
  const [modulosDisponiblesData, setModulosDisponiblesData] = useState([]);
  const [analisisSeleccionados, setAnalisisSeleccionados] = useState(new Set());
  const [codigoPendiente, setCodigoPendiente] = useState('');
  const [gruposExpandidos, setGruposExpandidos] = useState(new Set());
  
  // Estados para modal de histórico
  const [modalHistoricoOpen, setModalHistoricoOpen] = useState(false);
  const [historicoMuestra, setHistoricoMuestra] = useState([]);
  const [muestraHistoricoSeleccionada, setMuestraHistoricoSeleccionada] = useState(null);
  
  // Estados para condiciones de muestra  
  const [condicionesMuestra, setCondicionesMuestra] = useState([]);
  const [condicionMuestraSeleccionada, setCondicionMuestraSeleccionada] = useState('');
  const [cargandoCondicionesMuestra, setCargandoCondicionesMuestra] = useState(false);
  
  // Estados para Muestra Repetida
  const [motivosRepetida, setMotivosRepetida] = useState([]);
  const [motivoRepetidaSeleccionado, setMotivoRepetidaSeleccionado] = useState('');
  const [responsableRepetida, setResponsableRepetida] = useState('');
  const [cargandoMotivosRepetida, setCargandoMotivosRepetida] = useState(false);
  
  // Estados para cambio doble (TRASLADAR/VERIFICAR)
  const [usuarioTraslado, setUsuarioTraslado] = useState('');
  const [usuarioVerifica, setUsuarioVerifica] = useState('');
  const [fechaTraslado, setFechaTraslado] = useState(() => {
    // Inicializar con fecha y hora actual en formato datetime-local (YYYY-MM-DDTHH:mm)
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  });
  const [usuariosDisponibles, setUsuariosDisponibles] = useState([]);
  const [cargandoUsuarios, setCargandoUsuarios] = useState(false);
  
  // Estados para observaciones de muestras
  const [observacionesMuestras, setObservacionesMuestras] = useState(new Map());
  const [observacionesExpandidas, setObservacionesExpandidas] = useState(new Set());
  const textareaRefs = useRef(new Map());
  
  // Referencia para el input de código de barra (auto-focus)
  const barcodeInputRef = useRef(null);
  
  // Estado para controlar el loading de cambios de estado individuales
  const [muestrasIndividualesCargando, setMuestrasIndividualesCargando] = useState(new Set());

  // Estados para acciones masivas
  const [muestrasSeleccionadasMasivas, setMuestrasSeleccionadasMasivas] = useState([]);
  const [procesandoAccionMasiva, setProcesandoAccionMasiva] = useState(false);
  const [openComentarioModal, setOpenComentarioModal] = useState(false);
  const [comentarioTexto, setComentarioTexto] = useState('');
  const [pendingCambioEstado, setPendingCambioEstado] = useState(null);
  const [esCambioDobleEstado, setEsCambioDobleEstado] = useState(false);

  const { user } = useUser();
  const { sucursalSeleccionada } = useSucursal();
  const { tienePermiso } = useAccesos();

  // Funciones de utilidad completas (del TomaMuestra original)
  const getEstadoIcon = (estadoId) => {
    switch (estadoId) {
      case 1: return <PendingIcon />; // Pendiente
      case 5: return <StartIcon />; // Inicio Toma Muestra
      case 2: return <CompleteIcon />; // Toma Realizada
      case 8: return <ReceivedIcon />; // Traslado
      case 3: return <AnalysisIcon />; // Verificada
      case 9: return <MuestraNoConformeIcon />; // Muestra No conforme
      case 4: return <CompleteIcon />; // Procesada
      case 6: return <CancelIcon />; // Anulada
      case 7: return <PacienteAusenteIcon />; // Paciente Ausente
      case 11: return <RecepcionVentanillaIcon />; // RecepciÃ³n ventanilla
      default: return <PendingIcon />;
    }
  };

  const getEstadoDescription = (estadoId) => {
    switch (estadoId) {
      case 1: return 'Pendiente';
      case 5: return 'Inicio Toma Muestra';
      case 2: return 'Toma Realizada';
      case 8: return 'Traslado';
      case 3: return 'Verificada';
      case 9: return 'Muestra No conforme';
      case 4: return 'Procesada';
      case 6: return 'Anulada';
      case 7: return 'Paciente Ausente';
      case 11: return 'Recepción ventanilla';
      default: return 'Desconocido';
    }
  };

  const getEstadoColor = (estadoId) => {
    switch (estadoId) {
      case 1: return '#6c757d'; // Pendiente - Gris
      case 5: return '#ffc107'; // Inicio Toma Muestra - Amarillo  
      case 2: return '#28a745'; // Toma Realizada - Verde
      case 8: return '#17a2b8'; // Traslado - Azul
      case 3: return '#007bff'; // Verificada - Azul mÃ¡s oscuro
      case 9: return '#dc3545'; // Muestra No conforme - Rojo
      case 4: return '#20c997'; // Procesada - Teal
      case 6: return '#6610f2'; // Anulada - Morado
      case 7: return '#fd7e14'; // Paciente Ausente - Naranja
      case 11: return '#17a2b8'; // RecepciÃ³n ventanilla - Azul claro
      default: return '#6c757d';
    }
  };

  const getEstadoButtonColor = (estadoId) => {
    switch (estadoId) {
      case 1: return 'inherit';   // Pendiente
      case 5: return 'warning';   // Inicio Toma Muestra
      case 2: return 'success';   // Toma Realizada
      case 8: return 'info';      // Traslado
      case 3: return 'primary';   // Verificada
      case 9: return 'error';     // Muestra No conforme
      case 4: return 'info';      // Procesada
      case 6: return 'secondary'; // Anulada
      case 7: return 'warning';   // Paciente Ausente
      case 11: return 'info';     // RecepciÃ³n ventanilla
      default: return 'inherit';
    }
  };
  
  const getSiguienteEstado = (estadoActual, estadosDisponibles) => {
    const estadoActualObj = estadosDisponibles.find(e => e.id === estadoActual);
    if (!estadoActualObj) return null;
    
    const ordenActual = estadoActualObj.orden;
    const siguienteEstado = estadosDisponibles
      .filter(e => e.orden === ordenActual + 1)
      .sort((a, b) => a.orden - b.orden)[0];
    
    return siguienteEstado || null;
  };

  const formatUsuario = (usuario) => {
    if (!usuario) return ''.padEnd(20, ' ');
    return usuario.toString().padEnd(20, ' ').substring(0, 20);
  };
  
  // FunciÃ³n para obtener comentario por defecto segÃºn el estado
  const getComentarioPorDefecto = (estadoId, estadoAnterior, estadoNuevo) => {
    switch (estadoId) {
      case 3: // Verificada
        return `Muestra verificada en recepción. Cambio de ${estadoAnterior} a ${estadoNuevo}.`;
      case 6: // Anulada
        return `Muestra anulada. Motivo: [Especificar motivo de anulación]`;
      case 7: // Paciente Ausente
        return `Paciente ausente para toma de muestra. Fecha: ${new Date().toLocaleDateString()}. Motivo: [Especificar motivo de ausencia]`;
      case 11: // Recepción ventanilla
        return `Muestra pendiente en recepción de ventanilla. Fecha: ${new Date().toLocaleDateString()}. Motivo: [Especificar motivo de retención]`;
      case 5: // Inicio Toma Muestra
        return `Iniciando proceso de toma de muestra. Cambio de ${estadoAnterior} a ${estadoNuevo}.`;
      case 2: // Toma Realizada
        return `Toma de muestra realizada correctamente. Cambio de ${estadoAnterior} a ${estadoNuevo}.`;
      default:
        return `Cambio de estado de ${estadoAnterior} a ${estadoNuevo}. Observaciones adicionales si aplica.`;
    }
  };
  
  // FunciÃ³n para obtener estados disponibles desde la API
  const fetchEstadosDisponibles = async () => {
    try {
      const response = await fetch(`${server}/mg_estados_toma_muestras`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        },
      });

      if (response.ok) {
        const estadosData = await response.json();
        console.log('Estados obtenidos:', estadosData);
        
        const estadosArray = estadosData.$values || estadosData;
        console.log('Array de estados:', estadosArray);
        
        if (Array.isArray(estadosArray)) {
          const estadosOrdenados = estadosArray.sort((a, b) => (a.orden || 0) - (b.orden || 0));
          console.log('Estados ordenados:', estadosOrdenados);
          setEstadosDisponibles(estadosOrdenados);
        } else {
          console.error('Los estados no son un array:', estadosArray);
        }
      } else {
        console.error('Error al obtener estados:', response.statusText);
      }
    } catch (error) {
      console.error('Error al obtener los estados:', error);
    }
  };
  
  // FunciÃ³n para obtener condiciones de muestra filtradas
  const fetchCondicionesMuestra = async () => {
    setCargandoCondicionesMuestra(true);
    try {
      const response = await fetch(`${server}/CdmCondicionesEspeciales/demuestras`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${key}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        let condicionesArray = [];
        
        if (data && data.$values && Array.isArray(data.$values)) {
          condicionesArray = data.$values;
        } else if (Array.isArray(data)) {
          condicionesArray = data;
        }
        
        const condicionesLimpias = condicionesArray.map(condicion => ({
          id: condicion.IdCondicion || condicion.idCondicion || condicion.id,
          descripcion: condicion.DescripcionCondicion || condicion.descripcionCondicion || condicion.descripcion || 'Sin descripción'
        }));
        
        setCondicionesMuestra(condicionesLimpias);
      } else {
        console.error('Error al obtener condiciones de muestra:', response.statusText);
        setCondicionesMuestra([]);
      }
    } catch (error) {
      console.error('Error al obtener condiciones de muestra:', error);
      setCondicionesMuestra([]);
    } finally {
      setCargandoCondicionesMuestra(false);
    }
  };
  
  // Función para obtener motivos de muestra repetida
  const fetchMotivosRepetida = async () => {
    setCargandoMotivosRepetida(true);
    try {
      const response = await fetch(`${server}/CdmCondicionesEspeciales/derepetida`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${key}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        let motivosArray = [];
        
        if (data && data.$values && Array.isArray(data.$values)) {
          motivosArray = data.$values;
        } else if (Array.isArray(data)) {
          motivosArray = data;
        }
        
        const motivosLimpios = motivosArray.map(motivo => ({
          id: motivo.IdCondicion || motivo.idCondicion || motivo.id,
          descripcion: motivo.DescripcionCondicion || motivo.descripcionCondicion || motivo.descripcion || 'Sin descripción'
        }));
        
        setMotivosRepetida(motivosLimpios);
      } else {
        console.error('Error al obtener motivos de muestra repetida:', response.statusText);
        setMotivosRepetida([]);
      }
    } catch (error) {
      console.error('Error al obtener motivos de muestra repetida:', error);
      setMotivosRepetida([]);
    } finally {
      setCargandoMotivosRepetida(false);
    }
  };
  
  // Función para cargar usuarios disponibles
  const fetchUsuariosDisponibles = async () => {
    setCargandoUsuarios(true);
    try {
      const response = await fetch(`${server}/MgUsuarios`, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        }
      });

      if (!response.ok) {
        throw new Error('Error al cargar usuarios');
      }

      const data = await response.json();
      setUsuariosDisponibles(data.$values || []);
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      setUsuariosDisponibles([]);
    } finally {
      setCargandoUsuarios(false);
    }
  };

  // Funciones para acciones masivas
  const handleSeleccionMasivaChange = (muestraIndex, checked) => {
    if (checked) {
      setMuestrasSeleccionadasMasivas(prev => [...prev, muestraIndex]);
    } else {
      setMuestrasSeleccionadasMasivas(prev => prev.filter(index => index !== muestraIndex));
    }
  };

  const handleSeleccionarTodasMasiva = (checked) => {
    if (checked) {
      const todosIndices = muestrasEscaneadas.map((_, index) => index);
      setMuestrasSeleccionadasMasivas(todosIndices);
    } else {
      setMuestrasSeleccionadasMasivas([]);
    }
  };

  // Validar que todas las muestras seleccionadas tienen el mismo estado
  const validarMuestrasSeleccionadasMismoEstado = () => {
    // Detectar contexto: modal de detalle o tabla principal
    const seleccionadas = modalDetalleOpen ? muestrasDetalleSeleccionadas : muestrasSeleccionadasMasivas;
    const fuenteMuestras = modalDetalleOpen ? muestrasDetalle : muestrasEscaneadas;
    
    if (seleccionadas.length === 0) return { valido: false, mensaje: 'No hay muestras seleccionadas' };
    
    const estadoPrimera = fuenteMuestras[seleccionadas[0]]?.estadoActual || fuenteMuestras[seleccionadas[0]]?.idEstado || 1;
    const todosIgualEstado = seleccionadas.every(index => {
      const muestra = fuenteMuestras[index];
      const estadoMuestra = muestra?.estadoActual || muestra?.idEstado || 1;
      return muestra && estadoMuestra === estadoPrimera;
    });
    
    if (!todosIgualEstado) {
      return { valido: false, mensaje: 'Las muestras seleccionadas deben tener el mismo estado' };
    }
    
    return { valido: true, estadoComun: estadoPrimera };
  };

  // Obtener el siguiente estado disponible para acciones masivas (COMPLETO CON TODOS LOS ESTADOS)
  const obtenerEstadoSiguienteMasivo = () => {
    // Obtener estado comÃºn de las muestras seleccionadas (puede haber estados mixtos)
    const seleccionadas = modalDetalleOpen ? muestrasDetalleSeleccionadas : muestrasSeleccionadasMasivas;
    const fuenteMuestras = modalDetalleOpen ? muestrasDetalle : muestrasEscaneadas;
    
    if (seleccionadas.length === 0) return null;
    
    // Usar el estado mÃ¡s comÃºn o el primero
    const estadoPrimera = fuenteMuestras[seleccionadas[0]]?.estadoActual || fuenteMuestras[seleccionadas[0]]?.idEstado || 1;
    const estadoActual = estadoPrimera;
    
    if (!estadosDisponibles || estadosDisponibles.length === 0) {
      console.warn('No hay estados disponibles cargados');
      return null;
    }
    
    const estadoActualObj = estadosDisponibles.find(e => e.id === estadoActual);
    
    if (!estadoActualObj) {
      console.warn('Estado actual no encontrado:', estadoActual);
      return null;
    }
    
    console.log('obtenerEstadoSiguienteMasivo:', {
      estadoActual,
      estadoActualObj,
      orden: estadoActualObj.orden
    });
    
    const ordenActual = estadoActualObj.orden;
    
    // Obtener el siguiente estado en la secuencia
    const siguienteEstado = estadosDisponibles
      .filter(e => e.orden === ordenActual + 1)
      .sort((a, b) => a.orden - b.orden)[0];
    
    const opciones = [];
    
    // Estados especiales que tienen comportamiento particular
    const estadoAnulada = estadosDisponibles.find(e => e.estado === 'Anulada');
    const estadoPacienteAusente = estadosDisponibles.find(e => e.estado === 'Paciente Ausente');
    const estadoMuestraNoConforme = estadosDisponibles.find(e => 
      e.estado === 'Muestra No Conforme' || e.estado === 'Muestra No conforme'
    );
    const estadoPendiente = estadosDisponibles.find(e => e.estado === 'Pendiente');
    
    // Agregar siguiente estado secuencial como opciÃ³n primaria (si existe y no es estado especial)
    const esEstadoEspecial = ['Muestra No conforme', 'Muestra No Conforme', 'Anulada', 'Paciente Ausente', 'Muestra Repetida', 'Análisis Reprocesado', 'Analisis Reprocesado'].includes(estadoActualObj.estado);
    
    if (siguienteEstado && !esEstadoEspecial) {
      // CASO ESPECIAL: Si estamos en "Toma Realizada" y siguiente es "Traslado", ofrecer salto a "Verificada"
      const estadoTomaRealizadaOrden = estadosDisponibles.find(e => e.estado === 'Toma Realizada')?.orden;
      const estadoTrasladoOrden = estadosDisponibles.find(e => e.estado === 'Traslado')?.orden;
      const estadoVerificadaOrden = estadosDisponibles.find(e => e.estado === 'Verificada')?.orden;
      
      if (estadoActualObj.orden === estadoTomaRealizadaOrden && siguienteEstado.orden === estadoTrasladoOrden) {
        const estadoVerificada = estadosDisponibles.find(e => e.orden === estadoVerificadaOrden);
        if (estadoVerificada) {
          opciones.push({
            id: estadoVerificada.id,
            estado: 'TRASLADAR/VERIFICAR',
            isPrimary: true,
            requiereComentario: false,
            esCambioDoble: true
          });
        }
        opciones.push({
          id: siguienteEstado.id,
          estado: siguienteEstado.estado,
          isPrimary: false,
          requiereComentario: false
        });
      } else {
        opciones.push({
          id: siguienteEstado.id,
          estado: siguienteEstado.estado,
          isPrimary: true,
          requiereComentario: false
        });
      }
    }
    
    // Desde "Traslado" se puede ir a "Verificada"
    if (estadoActualObj.estado === 'Traslado') {
      const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
      if (estadoVerificada && !opciones.find(o => o.id === estadoVerificada.id)) {
        opciones.push({
          id: estadoVerificada.id,
          estado: 'Verificada',
          isPrimary: true,
          requiereComentario: false
        });
      }
    }
    
    // Desde "Pendiente" hay mÃºltiples opciones
    if (estadoActualObj.estado === 'Pendiente') {
      if (estadoPacienteAusente) {
        opciones.push({
          id: estadoPacienteAusente.id,
          estado: estadoPacienteAusente.estado,
          isPrimary: false,
          requiereComentario: true
        });
      }
      
      const estadoRecepcionVentanilla = estadosDisponibles.find(e => e.estado === 'Recepción ventanilla');
      if (estadoRecepcionVentanilla) {
        opciones.push({
          id: estadoRecepcionVentanilla.id,
          estado: estadoRecepcionVentanilla.estado,
          isPrimary: false,
          requiereComentario: false
        });
      }
    }
    
    // Agregar "Anular" desde cualquier estado (incluyendo Procesada)
    if (estadoAnulada && estadoActualObj.estado !== 'Anulada') {
      opciones.push({
        id: estadoAnulada.id,
        estado: 'Anular',
        isPrimary: false,
        requiereComentario: true
      });
    }
    
    // Agregar "Muestra No Conforme" desde varios estados
    if (estadoMuestraNoConforme && 
        !['Muestra No conforme', 'Muestra No Conforme', 'Anulada', 'Procesada', 'Muestra Repetida', 'Análisis Reprocesado', 'Analisis Reprocesado'].includes(estadoActualObj.estado)) {
      opciones.push({
        id: estadoMuestraNoConforme.id,
        estado: estadoMuestraNoConforme.estado,
        isPrimary: false,
        requiereComentario: true
      });
    }
    
    // Agregar "Muestra Repetida" solo desde Verificada (orden >= 5) en adelante
    const estadoMuestraRepetida = estadosDisponibles.find(e => e.estado === 'Muestra Repetida');
    const estadoVerificadaMasiva = estadosDisponibles.find(e => e.estado === 'Verificada');
    const ordenVerificadaMasiva = estadoVerificadaMasiva ? estadoVerificadaMasiva.orden : 5;
    if (estadoMuestraRepetida && 
        estadoActualObj.orden >= ordenVerificadaMasiva &&
        !['Muestra No conforme', 'Muestra No Conforme', 'Anulada', 'Procesada', 'Muestra Repetida', 'Análisis Reprocesado', 'Analisis Reprocesado'].includes(estadoActualObj.estado)) {
      opciones.push({
        id: estadoMuestraRepetida.id,
        estado: estadoMuestraRepetida.estado,
        isPrimary: false,
        requiereComentario: true
      });
    }
    
    // Desde "Muestra Repetida" permitir volver a Pendiente
    if (estadoActualObj.estado === 'Muestra Repetida' && estadoPendiente) {
      opciones.push({
        id: estadoPendiente.id,
        estado: 'Reactivar a Pendiente',
        isPrimary: true,
        requiereComentario: false
      });
    }
    
    // Desde "Análisis Reprocesado" permitir auto-transición
    const estadoReprocesado = estadosDisponibles.find(e => e.estado === 'Análisis Reprocesado' || e.estado === 'Analisis Reprocesado');
    if (estadoReprocesado && (estadoActualObj.estado === 'Análisis Reprocesado' || estadoActualObj.estado === 'Analisis Reprocesado')) {
      opciones.push({
        id: estadoReprocesado.id,
        estado: 'Reprocesar nuevamente',
        isPrimary: true,
        requiereComentario: false
      });
    }
    
    // Desde "Muestra No Conforme" permitir reactivaciÃ³n
    const desdeMuestraNoConforme = estadoActualObj.estado === 'Muestra No Conforme' || 
                                   estadoActualObj.estado === 'Muestra No conforme';
    if (desdeMuestraNoConforme && estadoPendiente) {
      opciones.push({
        id: estadoPendiente.id,
        estado: 'Reactivar a Pendiente',
        isPrimary: true,
        requiereComentario: false
      });
    }
    
    // Desde "Paciente Ausente" permitir continuar
    if (estadoActualObj.estado === 'Paciente Ausente' && siguienteEstado) {
      opciones.push({
        id: siguienteEstado.id,
        estado: `Continuar a ${siguienteEstado.estado}`,
        isPrimary: true,
        requiereComentario: false
      });
    }
    
    // Desde "RecepciÃ³n ventanilla" permitir continuar con opciÃ³n de cambio doble
    if (estadoActualObj.estado === 'Recepción ventanilla') {
      const estadoTraslado = estadosDisponibles.find(e => e.estado === 'Traslado');
      const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
      
      if (estadoTraslado && estadoVerificada) {
        // Agregar TRASLADAR/VERIFICAR como opciÃ³n primaria
        opciones.push({
          id: estadoVerificada.id,
          estado: 'TRASLADAR/VERIFICAR',
          isPrimary: true,
          requiereComentario: false,
          esCambioDoble: true,
          estadoIntermedio: estadoTraslado.id
        });
        // Agregar TRASLADO normal como opciÃ³n secundaria
        opciones.push({
          id: estadoTraslado.id,
          estado: estadoTraslado.estado,
          isPrimary: false,
          requiereComentario: false
        });
      } else if (estadoTraslado) {
        opciones.push({
          id: estadoTraslado.id,
          estado: `Continuar a ${estadoTraslado.estado}`,
          isPrimary: true,
          requiereComentario: false
        });
      }
    }
    
    // Desde "Verificada" permitir re-verificar con nuevos datos
    if (estadoActualObj.estado === 'Verificada') {
      const estadoTraslado = estadosDisponibles.find(e => e.estado === 'Traslado');
      const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
      
      if (estadoTraslado && estadoVerificada) {
        // Agregar RE-VERIFICAR como opciÃ³n primaria
        opciones.push({
          id: estadoVerificada.id,
          estado: 'RE-VERIFICAR',
          isPrimary: true,
          requiereComentario: false,
          esCambioDoble: true,
          estadoIntermedio: estadoTraslado.id
        });
      }
    }
    
    // Desde "Procesada" o cualquier otro estado, permitir TRASLADAR/VERIFICAR
    // Esto permite re-procesar, re-verificar o corregir muestras ya procesadas sin restricciones
    if (estadoActualObj.estado === 'Procesada' || 
        !opciones.find(o => o.esCambioDoble)) {
      const estadoTraslado = estadosDisponibles.find(e => e.estado === 'Traslado');
      const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
      
      if (estadoTraslado && estadoVerificada && !opciones.find(o => o.estado === 'TRASLADAR/VERIFICAR' || o.estado === 'RE-VERIFICAR')) {
        // Agregar TRASLADAR/VERIFICAR como opciÃ³n siempre disponible
        opciones.push({
          id: estadoVerificada.id,
          estado: 'TRASLADAR/VERIFICAR',
          isPrimary: true,
          requiereComentario: false,
          esCambioDoble: true,
          estadoIntermedio: estadoTraslado.id
        });
      }
    }
    
    console.log('Opciones generadas:', opciones);
    
    if (opciones.length === 0) {
      return null;
    }
    
    return {
      opciones,
      estadoAnterior: estadoActualObj
    };
  };

  // FunciÃ³n para ejecutar acciÃ³n masiva
  const handleAccionMasiva = async (opcion) => {
    console.log('handleAccionMasiva:', opcion);
    
    // ValidaciÃ³n eliminada: permitir procesar anÃ¡lisis con diferentes estados

    // Usar la fuente correcta segÃºn si estamos en modal de detalle o tabla principal
    const seleccionadas = modalDetalleOpen ? muestrasDetalleSeleccionadas : muestrasSeleccionadasMasivas;
    const fuenteMuestras = modalDetalleOpen ? muestrasDetalle : muestrasEscaneadas;
    
    // Filtrar Ã­ndices vÃ¡lidos y muestras existentes, eliminando undefined/null
    const muestrasConIndices = seleccionadas
      .map(index => ({ index, muestra: fuenteMuestras[index] }))
      .filter(item => item.muestra && item.muestra !== null && item.muestra !== undefined);
    
    if (muestrasConIndices.length === 0) {
      Swal.fire('Error', 'No hay muestras válidas seleccionadas para procesar', 'error');
      return;
    }
    
    const muestrasAfectadas = muestrasConIndices.map(item => item.muestra);
    const indicesValidos = muestrasConIndices.map(item => item.index);
    
    console.log('Muestras a procesar:', {
      totalSeleccionadas: seleccionadas.length,
      muestrasValidas: muestrasAfectadas.length,
      muestrasInvalidas: seleccionadas.length - muestrasAfectadas.length
    });
    
    // Obtener el estado de la primera muestra seleccionada
    const estadoPrimera = muestrasAfectadas[0]?.estadoActual || muestrasAfectadas[0]?.idEstado || 1;
    const estadoAnterior = estadosDisponibles.find(e => e.id === estadoPrimera);
    const estadoNuevo = estadosDisponibles.find(e => e.id === opcion.id);

    // Detectar si es cambio doble TRASLADAR/VERIFICAR
    if (opcion.esCambioDoble) {
      // Validar que los campos requeridos estÃ©n completos
      if (!usuarioTraslado.trim()) {
        Swal.fire('Error', 'Debe seleccionar el usuario que traslada', 'error');
        return;
      }
      if (!usuarioVerifica.trim()) {
        Swal.fire('Error', 'Debe seleccionar el usuario que verifica', 'error');
        return;
      }
      if (!fechaTraslado.trim()) {
        Swal.fire('Error', 'Debe ingresar la fecha y hora del traslado', 'error');
        return;
      }
      
      // Preparar datos para cambio doble
      const datosDobles = {
        muestraIndex: null,
        muestra: null,
        estadoAnterior,
        esMasiva: true,
        muestrasAfectadas,
        muestrasIndices: seleccionadas,
        enModalDetalle: modalDetalleOpen
      };
      
      // Ejecutar cambio doble directamente sin modal
      await procesarCambioEstadoDoble('Muestra verificada en recepción', usuarioTraslado, usuarioVerifica, fechaTraslado, datosDobles);
      return;
    }
    
    // Detectar si es Muestra No Conforme (requiere condiciÃ³n)
    const estadoMuestraNoConforme = estadosDisponibles.find(e => 
      e.estado === 'Muestra No Conforme' || e.estado === 'Muestra No conforme'
    );
    
    if (estadoMuestraNoConforme && opcion.id === estadoMuestraNoConforme.id) {
      setPendingCambioEstado({
        nuevoEstadoId: opcion.id,
        estadoNuevo,
        estadoAnterior,
        muestrasAfectadas,
        muestrasIndices: seleccionadas,
        estadoAnteriorId: estadoPrimera,
        enModalDetalle: modalDetalleOpen
      });
      setEsCambioDobleEstado(false);
      setComentarioTexto('');
      setOpenComentarioModal(true);
      return;
    }
    
    // Detectar si es Muestra Repetida (requiere motivo + responsable)
    const estadoMuestraRepetida = estadosDisponibles.find(e => e.estado === 'Muestra Repetida');
    if (estadoMuestraRepetida && opcion.id === estadoMuestraRepetida.id) {
      setPendingCambioEstado({
        nuevoEstadoId: opcion.id,
        estadoNuevo,
        estadoAnterior,
        muestrasAfectadas,
        muestrasIndices: seleccionadas,
        estadoAnteriorId: estadoPrimera,
        enModalDetalle: modalDetalleOpen,
        esMuestraRepetida: true
      });
      setEsCambioDobleEstado(false);
      setComentarioTexto('');
      setMotivoRepetidaSeleccionado('');
      setResponsableRepetida('');
      await Promise.all([fetchMotivosRepetida(), fetchUsuariosDisponibles()]);
      setOpenComentarioModal(true);
      return;
    }
    
    // Si requiere comentario, abrir modal
    if (opcion.requiereComentario) {
      setPendingCambioEstado({
        nuevoEstadoId: opcion.id,
        estadoNuevo,
        estadoAnterior,
        muestrasAfectadas,
        muestrasIndices: seleccionadas,
        estadoAnteriorId: estadoPrimera,
        enModalDetalle: modalDetalleOpen
      });
      setEsCambioDobleEstado(false);
      setComentarioTexto('');
      setOpenComentarioModal(true);
      return;
    }

    // Procesar sin comentario
    await procesarAccionMasivaSinConfirmacion(
      opcion.id, 
      estadoNuevo, 
      estadoAnterior, 
      muestrasAfectadas, 
      muestrasSeleccionadasMasivas
    );
  };

  // Procesar acciÃ³n masiva con comentario
  const procesarAccionMasivaConComentario = async (comentario) => {
    const { nuevoEstadoId, estadoNuevo, estadoAnterior, muestrasAfectadas, muestrasIndices } = pendingCambioEstado;
    
    setProcesandoAccionMasiva(true);
    
    try {
      let exitosas = 0;
      let fallidas = 0;
      const errores = [];

      // Procesar cada muestra seleccionada
      for (let i = 0; i < muestrasAfectadas.length; i++) {
        const muestra = muestrasAfectadas[i];
        const muestraIndex = muestrasIndices[i];
        
        try {
          const usuarioFormateado = formatUsuario(user ? user.codigoUsuario : 'ADMIN');
          const idSucursalFinal = sucursalSeleccionada?.idSucursal || null;
          
          const requestData = {
            IdOrden: muestra.idOrdenMedica,
            IdMuestraXAnalisis: muestra.idMuestraXAnalisis,
            EstadoAnterior: estadoAnterior?.id,
            NuevoEstado: nuevoEstadoId,
            UsuarioId: usuarioFormateado,
            Comentario: comentario.trim(),
            IdSucursal: idSucursalFinal,
            Cubiculo: null
          };

          console.log('[ACCIÓN MASIVA CON COMENTARIO] Enviando:', requestData);

          const response = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': key,
            },
            body: JSON.stringify(requestData)
          });

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Error al cambiar estado: ${errorText}`);
          }
          
          // Actualizar estado local
          setMuestrasEscaneadas(prev => 
            prev.map((m, index) => 
              index === muestraIndex 
                ? { ...m, estadoActual: nuevoEstadoId }
                : m
            )
          );
          
          exitosas++;
        } catch (error) {
          fallidas++;
          errores.push(`${muestra.descripcionMuestra}: ${error.message}`);
          console.error(`Error en muestra ${muestra.descripcionMuestra}:`, error);
        }
      }
      
      // Trackear los cambios de estado exitosos
      if (exitosas > 0) {
        trackearAccion('muestra_modificada', { cantidad: exitosas });
        trackearAccion('cambio_estado', {
          descripcion: `Acción masiva: ${estadoAnterior.estado} â†’ ${estadoNuevo.estado} (${exitosas} muestras)`,
          cantidadMuestras: exitosas,
          comentario: comentario.trim()
        });
      }

      // Mostrar resultado
      if (fallidas > 0) {
        Swal.fire({
          title: 'Acción completada con errores',
          html: `
            <strong>Exitosas:</strong> ${exitosas}<br>
            <strong>Fallidas:</strong> ${fallidas}<br><br>
            <strong>Errores:</strong><br>
            ${errores.join('<br>')}
          `,
          icon: 'warning'
        });
      } else {
        Swal.fire({
          title: 'Estado cambiado correctamente',
          text: `${exitosas} muestra(s) actualizadas`,
          icon: 'success',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false
        });
      }
      
      // Limpiar todo despuÃ©s de guardar
      if (exitosas > 0) {
        limpiarFormulario();
      }

    } catch (error) {
      console.error('Error en acción masiva:', error);
      Swal.fire('Error', 'Error al procesar la acción masiva', 'error');
    } finally {
      setProcesandoAccionMasiva(false);
      setOpenComentarioModal(false);
      setPendingCambioEstado(null);
    }
  };

  // Procesar acciÃ³n masiva sin confirmaciÃ³n
  const procesarAccionMasivaSinConfirmacion = async (nuevoEstadoId, estadoNuevo, estadoAnterior, muestrasAfectadas, muestrasIndices) => {
    setProcesandoAccionMasiva(true);
    
    try {
      let exitosas = 0;
      let fallidas = 0;
      const errores = [];

      // Generar comentario predeterminado
      const comentarioPorDefecto = getComentarioPorDefecto(nuevoEstadoId, estadoAnterior?.estado, estadoNuevo?.estado);

      // Procesar cada muestra seleccionada
      for (let i = 0; i < muestrasAfectadas.length; i++) {
        const muestra = muestrasAfectadas[i];
        const muestraIndex = muestrasIndices[i];
        
        try {
          const usuarioFormateado = formatUsuario(user ? user.codigoUsuario : 'ADMIN');
          const idSucursalFinal = sucursalSeleccionada?.idSucursal || null;
          
          const requestData = {
            IdOrden: muestra.idOrdenMedica,
            IdMuestraXAnalisis: muestra.idMuestraXAnalisis,
            EstadoAnterior: estadoAnterior?.id,
            NuevoEstado: nuevoEstadoId,
            UsuarioId: usuarioFormateado,
            Comentario: comentarioPorDefecto,
            IdSucursal: idSucursalFinal,
            Cubiculo: null
          };

          console.log('[ACCIÓN MASIVA SIN CONFIRMACIÓN] Enviando:', requestData);

          const response = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': key,
            },
            body: JSON.stringify(requestData)
          });

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Error al cambiar estado: ${errorText}`);
          }
          
          // Actualizar estado local
          setMuestrasEscaneadas(prev => 
            prev.map((m, index) => 
              index === muestraIndex 
                ? { ...m, estadoActual: nuevoEstadoId }
                : m
            )
          );
          
          exitosas++;
        } catch (error) {
          fallidas++;
          errores.push(`${muestra.descripcionMuestra}: ${error.message}`);
          console.error(`Error en muestra ${muestra.descripcionMuestra}:`, error);
        }
      }
      
      // Trackear los cambios de estado exitosos
      if (exitosas > 0) {
        trackearAccion('muestra_modificada', { cantidad: exitosas });
        trackearAccion('cambio_estado', {
          descripcion: `Acción masiva: ${estadoAnterior.estado} â†’ ${estadoNuevo.estado} (${exitosas} muestras)`,
          cantidadMuestras: exitosas
        });
      }

      // Mostrar resultado
      if (fallidas > 0) {
        Swal.fire({
          title: 'Acción completada con errores',
          html: `
            <strong>Exitosas:</strong> ${exitosas}<br>
            <strong>Fallidas:</strong> ${fallidas}<br><br>
            <strong>Errores:</strong><br>
            ${errores.join('<br>')}
          `,
          icon: 'warning'
        });
      } else if (exitosas > 0) {
        Swal.fire({
          title: 'Estado cambiado correctamente',
          text: `${exitosas} muestra(s) actualizadas`,
          icon: 'success',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false
        });
      }
      
      // Limpiar todo despuÃ©s de guardar
      if (exitosas > 0) {
        limpiarFormulario();
      }

    } catch (error) {
      console.error('Error en acción masiva:', error);
      Swal.fire('Error', 'Error al procesar la acción masiva', 'error');
    } finally {
      setProcesandoAccionMasiva(false);
    }
  };

  // FunciÃ³n para trackear acciones realizadas
  const trackearAccion = (tipo, detalle = null) => {
    setAccionesRealizadas(prev => {
      const nuevasAcciones = { ...prev };
      
      switch (tipo) {
        case 'muestra_modificada':
          nuevasAcciones.muestrasModificadas += 1;
          break;
        case 'etiquetas_impresas':
          nuevasAcciones.etiquetasImpresas += 1;
          break;
        case 'cambio_estado':
          nuevasAcciones.cambiosEstado.push({
            descripcion: detalle || 'Cambio de estado',
            timestamp: new Date()
          });
          break;
        default:
          break;
      }
      
      return nuevasAcciones;
    });
  };

  // FunciÃ³n para refrescar una muestra especÃ­fica despuÃ©s de cambios de estado
  const refrescarMuestra = async (idMuestraXAnalisis) => {
    try {
      console.log('Refrescando muestra:', idMuestraXAnalisis);
      
      // Buscar la muestra actual para obtener su cÃ³digo de barra
      const muestraActual = muestrasEscaneadas.find(m => m.idMuestraXAnalisis === idMuestraXAnalisis);
      if (!muestraActual || !muestraActual.codigoBarraEscaneado) {
        console.warn('No se encontró el código de barra de la muestra');
        return;
      }

      // Re-consultar los datos de la muestra
      const response = await fetch(`${server}/MgOrdenesMedicas/DecodificarCodigoMuestra/${muestraActual.codigoBarraEscaneado}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Datos refrescados de muestra:', data);
        // Preparar la muestra actualizada con el mismo formato
        const muestraActualizada = {
          ...data,
          codigoBarraEscaneado: muestraActual.codigoBarraEscaneado,
          fechaEscaneo: muestraActual.fechaEscaneo,
          usuario: muestraActual.usuario,
          idOrdenMedica: data.idOrdenMedica || data.idOrden || null,
          numeroOrden: data.numeroOrden || data.numeroOrdenMes || null,
          examenes: data.examenes?.$values || data.examenes || [],
          cantidadExamenes: data.cantidadExamenes || (data.examenes?.$values?.length || data.examenes?.length || 0),
          historico: data.historico?.$values || data.historico || []
        };
        
        // Intentar obtener el histÃ³rico actualizado desde el backend
        try {
          const historicoResponse = await fetch(`${server}/mg_historico_estados_muestras/muestra/${data.idMuestraXAnalisis}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': key,
            }
          });
          
          if (historicoResponse.ok) {
            const historicoData = await historicoResponse.json();
            const historicoArray = historicoData.$values || historicoData || [];
            if (historicoArray.length > 0) {
              muestraActualizada.historico = historicoArray;
              console.log('Histórico actualizado:', historicoArray.length, 'registros');
            }
          }
        } catch (error) {
          console.warn('No se pudo cargar el histórico actualizado:', error);
        }
        
        // Actualizar la muestra en el array
        setMuestrasEscaneadas(prev => 
          prev.map(m => 
            m.idMuestraXAnalisis === idMuestraXAnalisis ? muestraActualizada : m
          )
        );
        
        console.log('Muestra refrescada correctamente');
      }
    } catch (error) {
      console.error('Error al refrescar muestra:', error);
    }
  };

  // FunciÃ³n para escanear cÃ³digo de barra de muestra
  const handleEscanearMuestra = async (codigo) => {
    if (!codigo || codigo.trim() === '') {
      Swal.fire('Error', 'Debe ingresar un código de barra válido', 'error');
      return;
    }

    setLoading(true);
    try {
      // Llamar al endpoint para decodificar el cÃ³digo de barra de muestra
      const response = await fetch(`${server}/MgOrdenesMedicas/DecodificarCodigoMuestra/${codigo.trim()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Datos recibidos del escaneo:', data);
        // Verificar si el backend devuelve mÃºltiples mÃ³dulos (manejar patrÃ³n $values de Entity Framework)
        const muestrasMultiplesArray = data.muestrasMultiples?.$values || data.muestrasMultiples || [];
        
        if (data.tieneMultiplesModulos && muestrasMultiplesArray.length > 0) {
          // NOTA: Ya NO filtramos anÃ¡lisis escaneados - permitimos duplicados
          // Cada escaneo es una validaciÃ³n fÃ­sica independiente
          const modulosDisponibles = muestrasMultiplesArray.filter(m => m !== null);
          
          // Si hay mÃ¡s de un mÃ³dulo disponible, preguntar cuÃ¡l quiere agregar
          let muestraSeleccionada;
          
          if (modulosDisponibles.length > 1 || (modulosDisponibles.length === 1 && (modulosDisponibles[0].examenes?.$values || modulosDisponibles[0].examenes || []).length > 1)) {
            // Abrir modal de selecciÃ³n tÃ¡ctil para mÃ³dulos/anÃ¡lisis
            setModulosDisponiblesData(modulosDisponibles);
            setCodigoPendiente(codigo);
            
            // Si solo hay un grupo, auto-seleccionar todos los anÃ¡lisis
            if (modulosDisponibles.length === 1) {
              const nuevosSeleccionados = new Set();
              const examenes = modulosDisponibles[0].examenes?.$values || modulosDisponibles[0].examenes || [];
              examenes.forEach((examen, idx) => {
                const key = `0-${examen.idMuestraXAnalisis || examen.id}`;
                nuevosSeleccionados.add(key);
              });
              setAnalisisSeleccionados(nuevosSeleccionados);
            } else {
              setAnalisisSeleccionados(new Set());
            }
            
            // Todos los grupos colapsados por defecto
            setGruposExpandidos(new Set());
            setModalSeleccionAnalisisOpen(true);
            setLoading(false);
            return;
            
          } else {
            // Solo hay un mÃ³dulo con un anÃ¡lisis, usarlo directamente
            const muestraSeleccionada = modulosDisponibles[0];
            
            // Reemplazar data con la muestra seleccionada
            Object.keys(muestraSeleccionada).forEach(key => {
              data[key] = muestraSeleccionada[key];
            });
            
            // Manejar examenes con patrÃ³n $values
            if (muestraSeleccionada.examenes) {
              data.examenes = muestraSeleccionada.examenes.$values || muestraSeleccionada.examenes;
            }
          }
        }
        
        // Procesar la muestra (funciÃ³n comÃºn para evitar duplicaciÃ³n)
        await procesarMuestraEscaneada(data, codigo);
        
        setCodigoBarra('');
        setTimeout(() => barcodeInputRef.current?.focus(), 100);
        
      } else {
        const errorData = await response.json();
        Swal.fire('Error', errorData.message || 'Error al procesar el código de barra', 'error');
        setCodigoBarra('');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error al escanear muestra:', error);
      Swal.fire('Error', 'Error de conexión al procesar el código', 'error');
    } finally {
      setLoading(false);
    }
  };
  
  // FunciÃ³n auxiliar para procesar una muestra escaneada
  const procesarMuestraEscaneada = async (data, codigo, esSeleccionIndividualModal = false) => {
    try {
        // Normalizar examenes: manejar wrapper $values de serializaciÃ³n .NET
        if (data.examenes && !Array.isArray(data.examenes)) {
          data.examenes = data.examenes.$values || [];
        }

        // NOTA: Ya NO validamos duplicados - permitimos mÃºltiples registros del mismo anÃ¡lisis
        // Cada escaneo representa una validaciÃ³n fÃ­sica de muestra independiente
        // Esto permite: muestras de respaldo, doble validaciÃ³n, muestras para laboratorio externo

        // NOTA: Ya NO validamos el estado de la muestra - permitimos escanear en cualquier estado
        // Esto permite re-verificaciones, reprocesos y casos especiales del laboratorio
        const nuevaMuestra = {
          ...data,
          codigoBarraEscaneado: codigo.trim(),
          fechaEscaneo: new Date().toISOString(),
          usuario: user?.codigoUsuario || 'ADMIN',
          idOrdenMedica: data.idOrdenMedica || data.idOrden || null,
          numeroOrden: data.numeroOrden || data.numeroOrdenMes || null,
          examenes: data.examenes?.$values || data.examenes || [],
          cantidadExamenes: data.cantidadExamenes || (data.examenes?.$values?.length || data.examenes?.length || 0),
          historico: data.historico?.$values || data.historico || []
        };
        
        // Intentar obtener el histÃ³rico
        try {
          const historicoResponse = await fetch(`${server}/mg_historico_estados_muestras/muestra/${data.idMuestraXAnalisis}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': key,
            }
          });
          
          if (historicoResponse.ok) {
            const historicoData = await historicoResponse.json();
            const historicoArray = historicoData.$values || historicoData || [];
            if (historicoArray.length > 0) {
              nuevaMuestra.historico = historicoArray;
            }
          }
        } catch (error) {
          console.warn('No se pudo cargar el histórico:', error);
        }

        // Cada escaneo/selección del modal se agrega como una fila individual
        // Los anÃ¡lisis seleccionados juntos en el modal quedan agrupados en esa fila
        setMuestrasEscaneadas(prev => {
          const estadoGrupo = nuevaMuestra.estadoActual || nuevaMuestra.idEstado || 1;
          
          // Normalizar exámenes con el estado del grupo
          const examenesNormalizados = (nuevaMuestra.examenes || []).map(e => ({
            ...e,
            estadoActual: estadoGrupo,
            idEstado: estadoGrupo
          }));
          
          // Extraer TODOS los IDs de los anÃ¡lisis seleccionados en este escaneo
          const idsAnalisisSeleccionados = examenesNormalizados
            .map(e => e.idMuestraXAnalisis || e.id)
            .filter(id => id != null);
          
          // Crear nueva fila individual con todos los anÃ¡lisis seleccionados
          const nuevaFila = {
            ...nuevaMuestra,
            examenes: examenesNormalizados,
            cantidadExamenes: examenesNormalizados.length,
            estadoActual: estadoGrupo,
            idsMuestrasXAnalisis: idsAnalisisSeleccionados.length > 0 
              ? idsAnalisisSeleccionados 
              : [nuevaMuestra.idMuestraXAnalisis]
          };
          
          // Agregar como nueva fila al inicio
          return [nuevaFila, ...prev];
        });
        
        // Seleccionar automÃ¡ticamente
        setMuestrasSeleccionadasMasivas(prev => {
          const indicesActualizados = prev.map(idx => idx + 1);
          return [0, ...indicesActualizados];
        });
        
        const nombresAnalisis = (nuevaMuestra.examenes || [])
          .map(e => e.analisis || e.nombreAnalisis)
          .filter(Boolean)
          .join(', ');
        
        Swal.fire({
          title: 'âœ… Muestra agregada',
          html: `
            <strong>Orden:</strong> ${data.numeroOrden || 'N/A'}<br>
            <strong>Paciente:</strong> ${data.nombrePaciente || 'N/A'}<br>
            <strong>Módulo:</strong> ${data.modulo || 'N/A'}<br>
            <strong>Muestra:</strong> ${data.descripcionMuestra || 'N/A'}<br>
            <strong>Análisis (${(nuevaMuestra.examenes || []).length}):</strong> ${nombresAnalisis || 'N/A'}
          `,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false
        });
    } catch (error) {
      console.error('Error al procesar muestra escaneada:', error);
      Swal.fire('Error', `Error al procesar la muestra: ${error.message || 'Error desconocido'}`, 'error');
      setCodigoBarra('');
      setTimeout(() => barcodeInputRef.current?.focus(), 100);
    }
  };

  // FunciÃ³n para cambiar estado de muestra individual (VERSIÃ“N COMPLETA)
  const handleCambiarEstadoMuestra = async (muestraIndex, nuevoEstadoId) => {
    try {
      const muestra = muestrasEscaneadas[muestraIndex];
      if (!muestra) return;

      // Verificar si esta muestra ya estÃ¡ siendo procesada
      const muestraKey = `${muestraIndex}-${muestra.idMuestraXAnalisis}`;
      if (muestrasIndividualesCargando.has(muestraKey)) {
        console.log('Esta muestra ya está siendo procesada, ignorando duplicado');
        re1turn;
      }

      // Marcar la muestra como en proceso
      setMuestrasIndividualesCargando(prev => new Set([...prev, muestraKey]));

      // Obtener el estado actual real de la muestra
      const estadoActualId = muestra.estadoActual || 1;
      const estadoNuevo = estadosDisponibles.find(e => e.id === nuevoEstadoId);
      const estadoAnterior = estadosDisponibles.find(e => e.id === estadoActualId);
      
      if (!estadoNuevo || !estadoAnterior) {
        console.error('Estado no encontrado:', { nuevoEstadoId, estadoActualId, estadosDisponibles });
        throw new Error('Estado no válido');
      }
      
      // Detectar si es un cambio doble (TRASLADAR/VERIFICAR)
      const estadoTomaRealizadaOrden = estadosDisponibles.find(e => e.estado === 'Toma Realizada')?.orden;
      const estadoVerificadaOrden = estadosDisponibles.find(e => e.estado === 'Verificada')?.orden;
      const esCambioDoble = estadoAnterior.orden === estadoTomaRealizadaOrden && estadoNuevo.orden === estadoVerificadaOrden;
      
      // Validar que el cambio de estado respete la secuencia ordenada
      const ordenAnterior = estadoAnterior.orden;
      const ordenNuevo = estadoNuevo.orden;
      
      const esSecuencial = ordenNuevo === ordenAnterior + 1;
      const esEstadoEspecial = ['Anulada', 'Paciente Ausente', 'Muestra No Conforme', 'Muestra No conforme', 'Recepción ventanilla', 'Muestra Repetida', 'Análisis Reprocesado', 'Analisis Reprocesado'].includes(estadoNuevo.estado);
      const esReactivacion = (
        estadoAnterior.estado === 'Anulada' || 
        estadoAnterior.estado === 'Muestra No Conforme' || 
        estadoAnterior.estado === 'Muestra No conforme'
      ) && estadoNuevo.estado === 'Pendiente';
      const esDesdePacienteAusente = estadoAnterior.estado === 'Paciente Ausente';
      const esDesdeRecepcionVentanilla = estadoAnterior.estado === 'Recepción ventanilla';
      const esDesdeMuestraRepetida = estadoAnterior.estado === 'Muestra Repetida' && estadoNuevo.estado === 'Pendiente';
      const esAutoTransicionReprocesado = (estadoAnterior.estado === 'Análisis Reprocesado' || estadoAnterior.estado === 'Analisis Reprocesado') && 
                                            (estadoNuevo.estado === 'Análisis Reprocesado' || estadoNuevo.estado === 'Analisis Reprocesado');
      
      // ValidaciÃ³n especÃ­fica: desde "Muestra No conforme" solo se puede ir a "Pendiente"
      const desdeMuestraNoConforme = estadoAnterior.estado === 'Muestra No Conforme' || estadoAnterior.estado === 'Muestra No conforme';
      if (desdeMuestraNoConforme && estadoNuevo.estado !== 'Pendiente') {
        throw new Error(`Desde "Muestra No conforme" solo se puede reactivar a "Pendiente". No se puede cambiar directamente a "${estadoNuevo.estado}".`);
      }
      
      if (!esSecuencial && !esEstadoEspecial && !esReactivacion && !esDesdePacienteAusente && !esDesdeRecepcionVentanilla && !esCambioDoble && !esDesdeMuestraRepetida && !esAutoTransicionReprocesado) {
        throw new Error(`No se puede cambiar de "${estadoAnterior.estado}" (orden ${ordenAnterior}) a "${estadoNuevo.estado}" (orden ${ordenNuevo}). Debe seguir la secuencia ordenada.`);
      }
      
      console.log('Cambiando estado individual:', {
        estadoAnterior: estadoAnterior.estado,
        estadoNuevo: estadoNuevo.estado,
        ordenAnterior,
        ordenNuevo,
        muestra: muestra.descripcionMuestra,
        esCambioDoble
      });
      
      const esMuestraNoConforme = estadoNuevo.estado === 'Muestra No Conforme' || estadoNuevo.estado === 'Muestra No conforme';

      if (esCambioDoble) {
        // Validar que los campos requeridos estÃ©n completos
        if (!usuarioTraslado.trim()) {
          Swal.fire('Error', 'Debe seleccionar el usuario que traslada', 'error');
          setMuestrasIndividualesCargando(prev => {
            const newSet = new Set(prev);
            newSet.delete(muestraKey);
            return newSet;
          });
          return;
        }
        if (!usuarioVerifica.trim()) {
          Swal.fire('Error', 'Debe seleccionar el usuario que verifica', 'error');
          setMuestrasIndividualesCargando(prev => {
            const newSet = new Set(prev);
            newSet.delete(muestraKey);
            return newSet;
          });
          return;
        }
        if (!fechaTraslado.trim()) {
          Swal.fire('Error', 'Debe ingresar la fecha y hora del traslado', 'error');
          setMuestrasIndividualesCargando(prev => {
            const newSet = new Set(prev);
            newSet.delete(muestraKey);
            return newSet;
          });
          return;
        }
        
        // Preparar datos para cambio doble individual
        const datosDobles = {
          muestraIndex,
          muestra,
          estadoAnterior,
          esMasiva: false,
          muestrasAfectadas: [muestra],
          isIndividual: true
        };
        
        // Ejecutar cambio doble directamente sin modal
        await procesarCambioEstadoDoble('Muestra verificada en recepción', usuarioTraslado, usuarioVerifica, fechaTraslado, datosDobles);
      } else if (esMuestraNoConforme) {
        // Para Muestra No Conforme: siempre permitir comentario personalizado
        // Limpiar loading state antes de abrir modal para que el botón Confirmar no quede deshabilitado
        setMuestrasIndividualesCargando(prev => {
          const newSet = new Set(prev);
          newSet.delete(muestraKey);
          return newSet;
        });

        setPendingCambioEstado({
          muestraIndex,
          muestra,
          nuevoEstadoId,
          estadoNuevo,
          estadoAnterior,
          isIndividual: true
        });
        
        setComentarioTexto('');
        await fetchCondicionesMuestra();
        setOpenComentarioModal(true);
      } else if (estadoNuevo.estado === 'Muestra Repetida') {
        // Para Muestra Repetida: motivo + responsable + comentario
        setMuestrasIndividualesCargando(prev => {
          const newSet = new Set(prev);
          newSet.delete(muestraKey);
          return newSet;
        });

        setPendingCambioEstado({
          muestraIndex,
          muestra,
          nuevoEstadoId,
          estadoNuevo,
          estadoAnterior,
          isIndividual: true,
          esMuestraRepetida: true
        });
        
        setComentarioTexto('');
        setMotivoRepetidaSeleccionado('');
        setResponsableRepetida('');
        await Promise.all([fetchMotivosRepetida(), fetchUsuariosDisponibles()]);
        setOpenComentarioModal(true);
      } else {
        // Para todos los demÃ¡s casos: ejecutar directamente sin confirmaciÃ³n
        await procesarCambioEstadoIndividualSinConfirmacion(muestraIndex, muestra, nuevoEstadoId, estadoNuevo, estadoAnterior);
      }

    } catch (error) {
      console.error('Error al preparar cambio de estado individual:', error);
      Swal.fire('Error', error.message, 'error');
      
      // Limpiar el loading state en caso de error
      const muestra = muestrasEscaneadas[muestraIndex];
      if (muestra) {
        const muestraKey = `${muestraIndex}-${muestra.idMuestraXAnalisis}`;
        setMuestrasIndividualesCargando(prev => {
          const newSet = new Set(prev);
          newSet.delete(muestraKey);
          return newSet;
        });
      }
    }
  };
  
  // FunciÃ³n para procesar cambio de estado individual sin confirmaciÃ³n
  const procesarCambioEstadoIndividualSinConfirmacion = async (muestraIndex, muestra, nuevoEstadoId, estadoNuevo, estadoAnterior) => {
    try {
      const usuarioFormateado = formatUsuario(user ? user.codigoUsuario : 'ADMIN');
      const idSucursalFinal = sucursalSeleccionada?.idSucursal || null;
      
      // Generar comentario predeterminado
      const comentarioPorDefecto = getComentarioPorDefecto(nuevoEstadoId, estadoAnterior?.estado, estadoNuevo?.estado);
      
      // Buscar idOrdenMedica en diferentes campos posibles
      const idOrden = muestra.idOrdenMedica || muestra.idOrden || muestra.IdOrdenMedica || muestra.IdOrden;
      
      console.log('[DEBUG] Muestra completa:', muestra);
      console.log('[DEBUG] idOrden encontrado:', idOrden);
      
      if (!idOrden) {
        throw new Error('No se encontró el ID de la orden médica en los datos de la muestra');
      }
      
      // La fila puede contener mÃºltiples anÃ¡lisis (si fueron seleccionados juntos en el modal)
      const idsAnalisis = muestra.idsMuestrasXAnalisis || [muestra.idMuestraXAnalisis];
      const tieneMultiplesAnalisis = idsAnalisis.length > 1;
      
      console.log(`Procesando ${idsAnalisis.length} análisis de la fila${tieneMultiplesAnalisis ? ' (seleccionados juntos)' : ''}`);
      
      let exitosos = 0;
      let fallidos = 0;
      
      // Procesar cada anÃ¡lisis
      for (const idAnalisis of idsAnalisis) {
        try {
          const requestData = {
            IdOrden: idOrden,
            IdMuestraXAnalisis: idAnalisis,
            EstadoAnterior: estadoAnterior?.id,
            NuevoEstado: nuevoEstadoId,
            UsuarioId: usuarioFormateado,
            Comentario: comentarioPorDefecto,
            IdSucursal: idSucursalFinal,
            Cubiculo: null
          };

          console.log('[INDIVIDUAL] Enviando cambio de estado:', requestData);

          const response = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': key,
            },
            body: JSON.stringify(requestData)
          });

          if (!response.ok) {
            const errorText = await response.text();
            console.error(`Error en análisis ${idAnalisis}:`, errorText);
            fallidos++;
          } else {
            const responseData = await response.json();
            console.log(`Cambio exitoso (${idAnalisis}):`, responseData);
            exitosos++;
          }
        } catch (error) {
          console.error(`Error procesando análisis ${idAnalisis}:`, error);
          fallidos++;
        }
      }
      
      // Actualizar estado local solo si hubo al menos un exitoso
      if (exitosos > 0) {
        setMuestrasEscaneadas(prev => 
          prev.map((m, index) => 
            index === muestraIndex 
              ? { ...m, estadoActual: nuevoEstadoId }
              : m
          )
        );

        trackearAccion('cambio_estado', {
          descripcion: `${estadoAnterior?.estado} â†’ ${estadoNuevo?.estado}`,
          muestra: muestra.descripcionMuestra
        });

        // Refrescar la muestra para obtener histÃ³rico actualizado
        await refrescarMuestra(idsAnalisis[0]);
      }
      
      // Mostrar resultado
      if (fallidos === 0) {
        Swal.fire({
          title: 'Estado cambiado correctamente',
          text: tieneMultiplesAnalisis 
            ? `${exitosos} análisis cambiados: ${estadoAnterior?.estado} â†’ ${estadoNuevo?.estado}`
            : `${muestra.descripcionMuestra}: ${estadoAnterior?.estado} â†’ ${estadoNuevo?.estado}`,
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        Swal.fire({
          title: 'Proceso completado con errores',
          html: `
            <p>Exitosos: ${exitosos}</p>
            <p>Fallidos: ${fallidos}</p>
          `,
          icon: 'warning'
        });
      }

    } catch (error) {
      console.error('Error al cambiar estado individual:', error);
      Swal.fire({
        title: 'Error',
        text: `No se pudo cambiar el estado: ${error.message}`,
        icon: 'error'
      });
    } finally {
      const muestraKey = `${muestraIndex}-${muestra.idMuestraXAnalisis}`;
      setMuestrasIndividualesCargando(prev => {
        const newSet = new Set(prev);
        newSet.delete(muestraKey);
        return newSet;
      });
    }
  };
  
  // FunciÃ³n para obtener la fecha del Ãºltimo cambio al estado actual desde el histÃ³rico
  const obtenerFechaEstadoActual = async (idMuestraXAnalisis, idEstadoActual) => {
    try {
      const response = await fetch(`${server}/mg_historico_estados_muestras/muestra/${idMuestraXAnalisis}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        },
      });

      if (response.ok) {
        const historico = await response.json();
        const historicoArray = historico.$values || historico || [];
        
        // Buscar el registro mÃ¡s reciente del estado actual
        const registroEstadoActual = historicoArray
          .filter(h => h.id_estado_nuevo === idEstadoActual)
          .sort((a, b) => new Date(b.fecha_cambio_estado) - new Date(a.fecha_cambio_estado))[0];
        
        return registroEstadoActual?.fecha_cambio_estado || null;
      }
      return null;
    } catch (error) {
      console.error('Error obteniendo fecha del estado:', error);
      return null;
    }
  };

  // FunciÃ³n para calcular tiempo transcurrido y validar si excede el lÃ­mite permitido
  const calcularTiempoTranscurrido = (fechaInicio, fechaFin) => {
    if (!fechaInicio || !fechaFin) return null;
    
    const fechaInicioDate = new Date(fechaInicio);
    const fechaFinDate = new Date(fechaFin);
    
    // Calcular diferencia en minutos
    const diferenciaMs = fechaFinDate - fechaInicioDate;
    const diferenciaMinutos = Math.floor(diferenciaMs / (1000 * 60));
    const diferenciaHoras = Math.floor(diferenciaMinutos / 60);
    const minutosRestantes = diferenciaMinutos % 60;
    
    return {
      minutos: diferenciaMinutos,
      horas: diferenciaHoras,
      minutosRestantes: minutosRestantes,
      excedeLimite: diferenciaMinutos > 120, // MÃ¡s de 2 horas
      textoFormateado: diferenciaHoras > 0 
        ? `${diferenciaHoras}h ${minutosRestantes}m` 
        : `${diferenciaMinutos}m`,
      fechaInicio: fechaInicioDate.toLocaleString('es-ES'),
      fechaFin: fechaFinDate.toLocaleString('es-ES')
    };
  };
  
  // FunciÃ³n para procesar cambio doble de estado (TRASLADAR/VERIFICAR)
  const procesarCambioEstadoDoble = async (comentarioVerificada, usuarioTraslado, usuarioVerifica, fechaTraslado, datosDobles = null) => {
    try {
      // Obtener datos desde parÃ¡metro o desde pendingCambioEstado
      const datos = datosDobles || pendingCambioEstado;
      if (!datos) {
        throw new Error('No hay datos disponibles para procesar el cambio doble');
      }
      
      const { muestraIndex, muestra, estadoAnterior, esMasiva, muestrasAfectadas } = datos;
      const usuarioTrasladoFormateado = formatUsuario(usuarioTraslado);
      const usuarioVerificaFormateado = formatUsuario(usuarioVerifica);
      const idSucursalFinal = sucursalSeleccionada?.idSucursal || null;
      
      console.log('[CAMBIO DOBLE] Iniciando proceso TRASLADAR/VERIFICAR', {
        esMasiva,
        cantidadMuestras: esMasiva ? muestrasAfectadas?.length : 1,
        muestra: esMasiva ? 'Múltiples' : muestra?.descripcionMuestra,
        estadoAnterior: estadoAnterior.estado,
        usuarioTraslado,
        usuarioVerifica,
        fechaTraslado
      });

      // Obtener IDs de estados por nombre
      const estadoTraslado = estadosDisponibles.find(e => e.estado === 'Traslado');
      const estadoVerificada = estadosDisponibles.find(e => e.estado === 'Verificada');
      const estadoTomaRealizada = estadosDisponibles.find(e => e.estado === 'Toma Realizada');

      if (esMasiva) {
        // Procesar cambio doble masivo
        let exitosas = 0;
        let fallidas = 0;
        const errores = [];
        const muestrasPasadasTiempo = [];

        for (let i = 0; i < muestrasAfectadas.length; i++) {
          const muestraItem = muestrasAfectadas[i];
          
          // Validar que la muestra existe y tiene los datos necesarios
          if (!muestraItem || !muestraItem.idMuestraXAnalisis) {
            console.warn('Muestra inválida o sin idMuestraXAnalisis, saltando:', muestraItem);
            fallidas++;
            const muestraDesc = muestraItem?.descripcionMuestra || muestraItem?.modulo || 'Muestra sin identificar';
            errores.push(`${muestraDesc}: Datos de muestra inválidos o incompletos`);
            continue;
          }
          
          // La fila puede contener mÃºltiples anÃ¡lisis (seleccionados juntos originalmente)
          const idsAnalisis = muestraItem.idsMuestrasXAnalisis || [muestraItem.idMuestraXAnalisis];
          const tieneMultiplesAnalisis = idsAnalisis.length > 1;
          
          console.log(`Procesando ${idsAnalisis.length} análisis de "${muestraItem?.descripcionMuestra || 'N/A'}"${tieneMultiplesAnalisis ? ' (seleccionados juntos)' : ''}`);
          
          // Buscar idOrdenMedica en diferentes campos posibles
          const idOrden = muestraItem.idOrdenMedica || muestraItem.idOrden || muestraItem.IdOrdenMedica || muestraItem.IdOrden;
          
          if (!idOrden) {
            throw new Error('No se encontró el ID de la orden médica en los datos de la muestra');
          }
          
          // Procesar cada anÃ¡lisis del grupo
          for (const idAnalisis of idsAnalisis) {
            try {
              // Obtener la fecha del estado actual desde el histÃ³rico
              const fechaEstadoActual = await obtenerFechaEstadoActual(
                idAnalisis, 
                estadoAnterior.id
              );
              
              // Validar tiempo transcurrido desde el estado actual hasta la verificaciÃ³n
              if (fechaEstadoActual) {
                const tiempoInfo = calcularTiempoTranscurrido(fechaEstadoActual, fechaTraslado);
                if (tiempoInfo) {
                  console.log(`Análisis ${idAnalisis} de ${muestraItem?.descripcionMuestra || 'N/A'}:`, {
                    estadoAnterior: estadoAnterior?.estado,
                    fechaEstadoAnterior: tiempoInfo.fechaInicio,
                    fechaVerificacion: tiempoInfo.fechaFin,
                    tiempoTranscurrido: tiempoInfo.textoFormateado,
                    excedeLimite: tiempoInfo.excedeLimite
                  });
                  
                  if (tiempoInfo.excedeLimite) {
                    muestrasPasadasTiempo.push({
                      muestra: `${muestraItem?.descripcionMuestra || 'N/A'} (ID: ${idAnalisis})`,
                      tiempo: tiempoInfo.textoFormateado,
                      fechaEstadoAnterior: tiempoInfo.fechaInicio,
                      fechaVerificacion: tiempoInfo.fechaFin
                    });
                  }
                }
              }
              
              // PASO 1: Estado Actual â†’ Traslado
              const requestTraslado = {
                IdOrden: idOrden,
                IdMuestraXAnalisis: idAnalisis,
                EstadoAnterior: estadoAnterior.id,
                NuevoEstado: estadoTraslado.id,
                UsuarioId: formatUsuario(usuarioTraslado),
                Comentario: `Verificado por: ${usuarioTraslado}`,
                IdSucursal: idSucursalFinal,
                Cubiculo: null,
                FechaCambioEstado: fechaTraslado
              };

              const responseTraslado = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'x-api-key': key,
                },
                body: JSON.stringify(requestTraslado)
              });

              if (!responseTraslado.ok) {
                const errorText = await responseTraslado.text();
                throw new Error(`Error al registrar traslado para análisis ${idAnalisis}: ${errorText}`);
              }

              // PASO 2: Traslado â†’ Verificada
              const requestVerificada = {
                IdOrden: idOrden,
                IdMuestraXAnalisis: idAnalisis,
                EstadoAnterior: estadoTraslado.id,
                NuevoEstado: estadoVerificada.id,
                UsuarioId: usuarioVerificaFormateado,
                Comentario: `Verificado por: ${usuarioVerifica}`,
                IdSucursal: idSucursalFinal,
                Cubiculo: null
              };

              const responseVerificada = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'x-api-key': key,
                },
                body: JSON.stringify(requestVerificada)
              });

              if (!responseVerificada.ok) {
                const errorText = await responseVerificada.text();
                throw new Error(`Error al registrar verificada para análisis ${idAnalisis}: ${errorText}`);
              }
              
              console.log(`Análisis ${idAnalisis} procesado exitosamente`);
              exitosas++;
            } catch (error) {
              fallidas++;
              const muestraDesc = muestraItem?.descripcionMuestra || muestraItem?.modulo || muestraItem?.analisis || 'N/A';
              errores.push(`${muestraDesc} (ID: ${idAnalisis}): ${error.message}`);
              console.error(`Error en análisis ${idAnalisis} de ${muestraDesc}:`, error);
            }
          }
        }

        // Actualizar estado local de las muestras exitosas
        if (exitosas > 0) {
          setMuestrasEscaneadas(prev => 
            prev.map(muestra => {
              // Verificar si esta muestra fue procesada exitosamente
              const fueExitosa = muestrasAfectadas.some(m => {
                if (!m || !m.idMuestraXAnalisis) return false;
                const muestraDesc = m?.descripcionMuestra || m?.modulo || m?.analisis || '';
                return m.idMuestraXAnalisis === muestra.idMuestraXAnalisis &&
                  !errores.some(err => err.includes(muestraDesc));
              });
              
              if (fueExitosa) {
                return { ...muestra, estadoActual: estadoVerificada.id };
              }
              return muestra;
            })
          );
        }

        // Mostrar resultado
        if (exitosas > 0) {
          let alertaHTML = `
            <div style="text-align: left; padding: 10px;">
              <p><strong>Exitosas: ${exitosas}</strong></p>
              ${fallidas > 0 ? `<p><strong>Fallidas: ${fallidas}</strong></p>` : ''}
              <p>Proceso completado:</p>
              <p>${estadoAnterior.estado} â†’ Traslado (${usuarioTraslado})</p>
              <p>Traslado â†’ Verificada (${usuarioVerifica})</p>
          `;
          
          // Agregar advertencia de muestras pasadas de tiempo si existen
          if (muestrasPasadasTiempo.length > 0) {
            alertaHTML += `
              <hr style="margin: 15px 0;">
              <div style="background-color: #fff3cd; padding: 10px; border-radius: 5px; border-left: 4px solid #ffc107;">
                <p style="color: #856404; margin: 0; font-weight: bold;">ADVERTENCIA: Muestras fuera del tiempo permitido</p>
                <p style="color: #856404; margin: 5px 0 10px 0; font-size: 0.9em;">Las siguientes muestras exceden el tiempo recomendado (>2 horas):</p>
                <ul style="margin: 0; padding-left: 20px; color: #856404;">
            `;
            
            muestrasPasadasTiempo.forEach(item => {
              alertaHTML += `
                <li style="margin-bottom: 10px;">
                  <strong>${item.muestra}:</strong><br/>
                  <span style="font-size: 0.85em;">
                    Estado ${estadoAnterior.estado}: ${item.fechaEstadoAnterior}<br/>
                    Verificación: ${item.fechaVerificacion}<br/>
                    <strong>Tiempo transcurrido: ${item.tiempo}</strong>
                  </span>
                </li>
              `;
            });
            
            alertaHTML += `
                </ul>
              </div>
            `;
          }
          
          alertaHTML += '</div>';
          
          Swal.fire({
            title: 'Verificación completada',
            html: alertaHTML,
            icon: muestrasPasadasTiempo.length > 0 ? 'warning' : 'success',
            confirmButtonText: 'Entendido',
            timer: 2200,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: {
              popup: 'swal-wide'
            }
          });
        }
        
        // Trackear acciÃ³n
        if (exitosas > 0) {
          trackearAccion('cambio_estado', {
            descripcion: `TRASLADAR/VERIFICAR masivo (${exitosas} muestras)`,
            cantidadMuestras: exitosas
          });
        }
        
        // Limpiar todo despuÃ©s de guardar
        setProcesandoAccionMasiva(false);
        limpiarFormulario();
      } else {
        // Procesar cambio doble individual
        // Buscar idOrdenMedica en diferentes campos posibles
        const idOrden = muestra.idOrdenMedica || muestra.idOrden || muestra.IdOrdenMedica || muestra.IdOrden;
        
        if (!idOrden) {
          throw new Error('No se encontró el ID de la orden médica en los datos de la muestra');
        }
        
        // Obtener la fecha del estado actual desde el histÃ³rico
        const fechaEstadoActual = await obtenerFechaEstadoActual(
          muestra.idMuestraXAnalisis, 
          estadoAnterior.id
        );
        
        // Validar tiempo transcurrido desde el estado actual hasta la verificaciÃ³n
        let tiempoInfo = null;
        if (fechaEstadoActual) {
          tiempoInfo = calcularTiempoTranscurrido(fechaEstadoActual, fechaTraslado);
          
          if (tiempoInfo) {
            console.log(`Tiempo transcurrido para ${muestra?.descripcionMuestra || 'muestra'}:`, {
              estadoAnterior: estadoAnterior?.estado,
              fechaEstadoAnterior: tiempoInfo.fechaInicio,
              fechaVerificacion: tiempoInfo.fechaFin,
              tiempoTranscurrido: tiempoInfo.textoFormateado,
              excedeLimite: tiempoInfo.excedeLimite
            });
          }
        }
        
        // PASO 1: Estado Actual â†’ Traslado
        const requestTraslado = {
          IdOrden: idOrden,
          IdMuestraXAnalisis: muestra.idMuestraXAnalisis,
          EstadoAnterior: estadoAnterior.id,
          NuevoEstado: estadoTraslado.id,
          UsuarioId: formatUsuario(usuarioTraslado),
          Comentario: `Verificado por: ${usuarioTraslado}`,
          IdSucursal: idSucursalFinal,
          Cubiculo: null,
          FechaCambioEstado: fechaTraslado
        };

        console.log('[PASO 1] Registrando Traslado:', requestTraslado);

        const responseTraslado = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': key,
          },
          body: JSON.stringify(requestTraslado)
        });

        if (!responseTraslado.ok) {
          const errorText = await responseTraslado.text();
          throw new Error(`Error al registrar traslado: ${errorText}`);
        }

        console.log('[PASO 1] Traslado registrado exitosamente');

        // PASO 2: Traslado â†’ Verificada
        const requestVerificada = {
          IdOrden: idOrden,
          IdMuestraXAnalisis: muestra.idMuestraXAnalisis,
          EstadoAnterior: estadoTraslado.id,
          NuevoEstado: estadoVerificada.id,
          UsuarioId: usuarioVerificaFormateado,
          Comentario: `Verificado por: ${usuarioVerifica}`,
          IdSucursal: idSucursalFinal,
          Cubiculo: null
        };

        console.log('[PASO 2] Registrando Verificada:', requestVerificada);

        const responseVerificada = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': key,
          },
          body: JSON.stringify(requestVerificada)
        });

        if (!responseVerificada.ok) {
          const errorText = await responseVerificada.text();
          throw new Error(`Error al registrar verificada: ${errorText}`);
        }

        console.log('[PASO 2] Verificada registrada exitosamente');

        // Mostrar mensaje de Ã©xito con advertencia de tiempo si excede lÃ­mite
        let mensajeHTML = `
          <div style="text-align: left; padding: 10px;">
            <p><strong>Cambio doble realizado exitosamente</strong></p>
            <p>Muestra: ${muestra.descripcionMuestra}</p>
            <p>${estadoAnterior.estado} â†’ Traslado (${usuarioTraslado})</p>
            <p>Traslado â†’ Verificada (${usuarioVerifica})</p>
        `;
        
        if (tiempoInfo) {
          if (tiempoInfo.excedeLimite) {
            mensajeHTML += `
              <hr style="margin: 15px 0;">
              <div style="background-color: #fff3cd; padding: 10px; border-radius: 5px; border-left: 4px solid #ffc107;">
                <p style="color: #856404; margin: 0; font-weight: bold;">ADVERTENCIA: Muestra fuera del tiempo permitido</p>
                <p style="color: #856404; margin: 5px 0; font-size: 0.9em;">
                  Estado ${estadoAnterior.estado}: ${tiempoInfo.fechaInicio}<br/>
                  Verificación: ${tiempoInfo.fechaFin}<br/>
                  <strong>Tiempo transcurrido: ${tiempoInfo.textoFormateado}</strong> (lí­mite: 2 horas)
                </p>
              </div>
            `;
          } else {
            mensajeHTML += `
              <hr style="margin: 15px 0;">
              <div style="background-color: #d4edda; padding: 10px; border-radius: 5px; border-left: 4px solid #28a745;">
                <p style="color: #155724; margin: 0; font-weight: bold;">Tiempo dentro del lí­mite permitido</p>
                <p style="color: #155724; margin: 5px 0 0 0; font-size: 0.9em;">
                  Estado ${estadoAnterior.estado}: ${tiempoInfo.fechaInicio}<br/>
                  Verificación: ${tiempoInfo.fechaFin}<br/>
                  <strong>Tiempo transcurrido: ${tiempoInfo.textoFormateado}</strong>
                </p>
              </div>
            `;
          }
        }
        
        mensajeHTML += '</div>';
        
        Swal.fire({
          title: 'Verificación Completada',
          html: mensajeHTML,
          icon: tiempoInfo && tiempoInfo.excedeLimite ? 'warning' : 'success',
          confirmButtonText: 'Entendido',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false
        });

        // Limpiar todo despuÃ©s de guardar
        limpiarFormulario();
      }
      
    } catch (error) {
      console.error('Error en cambio doble:', error);
      Swal.fire({
        title: 'Error',
        text: `No se pudo completar el cambio doble: ${error.message}`,
        icon: 'error'
      });
    } finally {
      if (pendingCambioEstado?.esMasiva) {
        setProcesandoAccionMasiva(false);
      } else if (pendingCambioEstado?.muestraIndex !== undefined) {
        const muestraKey = `${muestra?.id}-${muestra?.idMuestraXAnalisis}`;
        setMuestrasIndividualesCargando(prev => {
          const newSet = new Set(prev);
          newSet.delete(muestraKey);
          return newSet;
        });
      }
    }
  };
  
  // FunciÃ³n para procesar cambio de estado individual con comentario
  const procesarCambioEstadoIndividualConComentario = async (comentario) => {
    try {
      const { muestraIndex, muestra, nuevoEstadoId, estadoNuevo, estadoAnterior } = pendingCambioEstado;
      
      const usuarioFormateado = formatUsuario(user ? user.codigoUsuario : 'ADMIN');
      const idSucursalFinal = sucursalSeleccionada?.idSucursal || null;
      
      // Buscar idOrdenMedica en diferentes campos posibles
      const idOrden = muestra.idOrdenMedica || muestra.idOrden || muestra.IdOrdenMedica || muestra.IdOrden;
      
      if (!idOrden) {
        throw new Error('No se encontró el ID de la orden médica en los datos de la muestra');
      }
      
      const requestData = {
        IdOrden: idOrden,
        IdMuestraXAnalisis: muestra.idMuestraXAnalisis,
        EstadoAnterior: estadoAnterior?.id,
        NuevoEstado: nuevoEstadoId,
        UsuarioId: usuarioFormateado,
        Comentario: comentario.trim(),
        IdSucursal: idSucursalFinal,
        Cubiculo: null
      };

      console.log('[INDIVIDUAL CON COMENTARIO] Enviando cambio de estado:', requestData);

      const response = await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error en la respuesta del servidor:', errorText);
        throw new Error(`Error al cambiar estado: ${errorText}`);
      }

      const responseData = await response.json();
      console.log('Respuesta del cambio de estado:', responseData);

      // Actualizar estado local
      setMuestrasEscaneadas(prev => 
        prev.map((m, index) => 
          index === muestraIndex 
            ? { ...m, estadoActual: nuevoEstadoId }
            : m
        )
      );

      trackearAccion('cambio_estado', {
        descripcion: `${estadoAnterior?.estado} â†’ ${estadoNuevo?.estado}`,
        muestra: muestra.descripcionMuestra,
        comentario: comentario.trim()
      });

      // Refrescar la muestra para obtener histÃ³rico actualizado
      await refrescarMuestra(muestra.idMuestraXAnalisis);

      Swal.fire({
        title: 'Estado cambiado correctamente',
        text: `${muestra.descripcionMuestra}: ${estadoAnterior?.estado} â†’ ${estadoNuevo?.estado}`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
      
    } catch (error) {
      console.error('Error al cambiar estado individual:', error);
      Swal.fire({
        title: 'Error',
        text: `No se pudo cambiar el estado: ${error.message}`,
        icon: 'error'
      });
    } finally {
      const { muestraIndex, muestra } = pendingCambioEstado;
      const muestraKey = `${muestraIndex}-${muestra.idMuestraXAnalisis}`;
      setMuestrasIndividualesCargando(prev => {
        const newSet = new Set(prev);
        newSet.delete(muestraKey);
        return newSet;
      });
    }
  };

  // Funciones para impresiÃ³n de etiquetas (adaptadas)
  
  // FunciÃ³n para agrupar muestras por mÃ³dulo + descripciÃ³n + cantidad (igual que OrdenesTrabajo)
  const agruparMuestrasParaEtiquetas = (muestrasData) => {
    const muestrasAgrupadas = new Map();
    
    muestrasData.forEach((muestra) => {
      // Crear una clave Ãºnica para agrupar por mÃ³dulo, descripciÃ³n de muestra y cantidad
      const clave = `${muestra.descripcionMuestra}-${muestra.modulo}-${muestra.descripcionCantidad}`;
      
      if (muestrasAgrupadas.has(clave)) {
        // Si ya existe, agregar el anÃ¡lisis a la lista
        const muestraExistente = muestrasAgrupadas.get(clave);
        muestraExistente.analisis.push(muestra.analisis || muestra.nombreAnalisis);
        muestraExistente.examenes.push(muestra);
      } else {
        // Crear nueva entrada agrupada
        muestrasAgrupadas.set(clave, {
          claveGrupo: clave,
          modulo: muestra.modulo || 'N/A',
          descripcionMuestra: muestra.descripcionMuestra,
          descripcionCantidad: muestra.descripcionCantidad,
          observaciones: muestra.observaciones,
          analisis: [muestra.analisis || muestra.nombreAnalisis],
          examenes: [muestra],
          esCobas303: muestra.esCobas303 || false,
          cantidadMuestras: 1
        });
      }
    });
    
    // Convertir el Map a array y formatear anÃ¡lisis
    const resultado = Array.from(muestrasAgrupadas.values()).map(muestra => ({
      ...muestra,
      analisisTexto: muestra.analisis.join(', '),
      cantidadMuestras: muestra.examenes.length
    }));
    
    return resultado;
  };
  
  const handleAbrirImprimirEtiquetas = () => {
    // Detectar si es sucursal principal (ID = 1) 
    const esSucursalPrincipal = sucursalSeleccionada?.idSucursal === 1;
    
    // Actualizar las muestras para incluir el campo esCobas303
    const muestrasActualizadas = muestrasEscaneadas.map(muestra => {
      // Pre-seleccionar COBAS si es sucursal principal Y mÃ³dulo es bioquÃ­mica clÃ­nica
      const moduloTexto = (muestra.modulo || '').toLowerCase();
      const esBioquimicaClinica = moduloTexto.includes('bioquimica') || 
                                  moduloTexto.includes('bioquí­mica') ||
                                  (moduloTexto.includes('bio') && moduloTexto.includes('clinica'));
      
      const preSeleccionarCobas = esSucursalPrincipal && esBioquimicaClinica;
      
      return {
        ...muestra,
        esCobas303: preSeleccionarCobas || muestra.esCobas303 || false
      };
    });
    
    setMuestrasEscaneadas(muestrasActualizadas);
    setImprimirEtiquetasOpen(true);
  };

  const handleCerrarImprimirEtiquetas = () => {
    setImprimirEtiquetasOpen(false);
    setMuestrasSeleccionadas([]);
  };

  const handleSeleccionarTodasMuestras = (checked) => {
    if (checked) {
      const todasIds = muestrasEscaneadas.map(muestra => muestra.idMuestraXAnalisis);
      setMuestrasSeleccionadas(todasIds);
    } else {
      setMuestrasSeleccionadas([]);
    }
  };

  const handleMuestraSeleccionChange = (idMuestraXAnalisis, checked) => {
    if (checked) {
      setMuestrasSeleccionadas(prev => [...prev, idMuestraXAnalisis]);
    } else {
      setMuestrasSeleccionadas(prev => prev.filter(id => id !== idMuestraXAnalisis));
    }
  };

  const handleImprimirEtiquetas = async () => {
    if (muestrasSeleccionadas.length === 0) {
      Swal.fire({
        title: 'Seleccione muestras',
        text: 'Debe seleccionar al menos una muestra para imprimir etiquetas',
        icon: 'warning'
      });
      return;
    }

    try {
      // Agrupar muestras por orden para enviar por separado
      const muestrasPorOrden = {};
      
      muestrasSeleccionadas.forEach(idMuestra => {
        const muestra = muestrasEscaneadas.find(m => m.idMuestraXAnalisis === idMuestra);
        if (muestra && muestra.idOrdenMedica) {
          if (!muestrasPorOrden[muestra.idOrdenMedica]) {
            muestrasPorOrden[muestra.idOrdenMedica] = [];
          }
          muestrasPorOrden[muestra.idOrdenMedica].push({
            IdMuestraXAnalisis: idMuestra,
            EsCobas303: muestra?.esCobas303 || false
          });
        }
      });

      // Procesar cada orden por separado
      const pdfUrls = [];
      for (const [idOrden, muestrasOrden] of Object.entries(muestrasPorOrden)) {
        const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirEtiquetasSeleccionadas/${idOrden}?anchoMM=60&altoMM=30`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(muestrasOrden)
        });

        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          pdfUrls.push(url);
        }
      }

      if (pdfUrls.length > 0) {
        // Si hay múltiples PDFs, mostrar el primero (podrÃ­as mejorar esto)
        setEtiquetasPdfUrl(pdfUrls[0]);
        setOpenEtiquetasPreview(true);
        setImprimirEtiquetasOpen(false);
        
        trackearAccion('etiquetas_impresas');
        
        Swal.fire({
          title: 'Éxito',
          text: `Se generaron etiquetas para ${Object.keys(muestrasPorOrden).length} orden(es)`,
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      }
    } catch (error) {
      console.error('Error al imprimir etiquetas:', error);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al generar las etiquetas',
        icon: 'error'
      });
    }
  };

  // Funciones para gestiÃ³n de cubÃ­culo
  const handleGuardarCubiculo = (cubiculo) => {
    setCubiculoSeleccionado(cubiculo);
    localStorage.setItem('cubiculoTomaMuestra', cubiculo);
    setModalCubiculoOpen(false);
    setMostrarAlertaCubiculo(false);
    
    if (cubiculo) {
      Swal.fire({
        title: 'Cubí­culo Seleccionado',
        text: `Trabajando en: ${cubiculo}`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
    }
  };

  const handleAbrirGestionCubiculo = () => {
    setModalCubiculoOpen(true);
  };

  // FunciÃ³n para abrir modal de detalle individual
  const handleAbrirDetalleModal = async (muestra, muestraIndex) => {
    try {
      console.log('Abriendo modal de detalle para:', muestra);
      
      // Limpiar selecciÃ³n al abrir el modal
      setMuestrasDetalleSeleccionadas([]);
      
      // âœ… NUEVO: Primero intentar usar los exÃ¡menes que vienen en la muestra desde DecodificarCodigoMuestra
      if (muestra.examenes && Array.isArray(muestra.examenes) && muestra.examenes.length > 0) {
        console.log('Usando examenes del campo examenes:', muestra.examenes.length);
        
        // Normalizar el estado de todos los exÃ¡menes al estado de la fila agrupada
        const estadoGrupo = muestra.estadoActual || muestra.idEstado || 1;
        const examenesNormalizados = muestra.examenes.map(e => ({
          ...e,
          estadoActual: estadoGrupo,
          idEstado: estadoGrupo
        }));
        
        const grupoConExamenes = {
          ...muestra,
          examenes: examenesNormalizados,
          cantidadMuestras: muestra.cantidadExamenes || muestra.examenes.length,
          ComparteCon: examenesNormalizados.map(e => e.analisis || e.nombreAnalisis).filter(Boolean).join(', ')
        };
        
        setGrupoSeleccionado(grupoConExamenes);
        setMuestrasDetalle(examenesNormalizados);
        setModalDetalleOpen(true);
        return;
      }
      
      // Fallback 1: Buscar en muestras escaneadas locales
      console.log('No hay examenes en la muestra, buscando en muestras locales');
      const idOrden = muestra.idOrdenMedica || muestra.idOrden || muestra.numeroOrden;
      
      if (!idOrden) {
        console.warn('No se encontró ID de orden');
        
        // Fallback final: mostrar solo esta muestra
        const grupoFallback = {
          ...muestra,
          examenes: [muestra],
          cantidadMuestras: 1,
          ComparteCon: muestra.analisis || muestra.descripcionTipoAnalisis || 'N/A'
        };
        
        setGrupoSeleccionado(grupoFallback);
        setMuestrasDetalle([muestra]);
        setModalDetalleOpen(true);
        return;
      }
      
      // Buscar todas las muestras escaneadas de la misma orden que compartan mÃ³dulo, tipo y cantidad
      const muestrasRelacionadasLocal = muestrasEscaneadas.filter(m => {
        const mismaOrden = m.idOrdenMedica === idOrden || m.numeroOrden === muestra.numeroOrden;
        const mismoModulo = m.modulo === muestra.modulo || m.idModulo === muestra.idModulo;
        const mismaMuestra = m.descripcionMuestra === muestra.descripcionMuestra;
        const mismaCantidad = m.cantidad === muestra.cantidad || m.descripcionCantidad === muestra.descripcionCantidad;
        
        return mismaOrden && mismoModulo && mismaMuestra && mismaCantidad;
      });
      
      console.log('Muestras relacionadas locales:', muestrasRelacionadasLocal.length);
      
      if (muestrasRelacionadasLocal.length === 0) {
        muestrasRelacionadasLocal.push(muestra);
      }
      
      const grupoLocal = {
        ...muestra,
        examenes: muestrasRelacionadasLocal,
        cantidadMuestras: muestrasRelacionadasLocal.length,
        ComparteCon: muestrasRelacionadasLocal.map(m => m.analisis || m.descripcionTipoAnalisis).filter(Boolean).join(', ')
      };
      
      setGrupoSeleccionado(grupoLocal);
      setMuestrasDetalle(muestrasRelacionadasLocal);
      setModalDetalleOpen(true);
      
    } catch (error) {
      console.error('Error al abrir modal de detalle:', error);
      
      // Fallback absoluto: mostrar solo la muestra actual
      const grupoFallback = {
        ...muestra,
        examenes: [muestra],
        cantidadMuestras: 1,
        ComparteCon: muestra.analisis || muestra.descripcionTipoAnalisis || 'N/A'
      };
      
      setGrupoSeleccionado(grupoFallback);
      setMuestrasDetalle([muestra]);
      setModalDetalleOpen(true);
    }
  };
  
  // FunciÃ³n para cerrar modal de detalle
  const handleCerrarDetalleModal = () => {
    setModalDetalleOpen(false);
    setGrupoSeleccionado(null);
    setMuestrasDetalle([]);
    setMuestrasDetalleSeleccionadas([]); // Limpiar selecciÃ³n al cerrar
  };
  
  // FunciÃ³n para abrir modal de histÃ³rico
  const handleAbrirHistorico = async (muestra) => {
    try {
      console.log('Abriendo histórico para muestra:', muestra);
      console.log('ID Muestra X Análisis:', muestra.idMuestraXAnalisis);
      console.log('Histórico directo:', muestra.historico);
      
      // Intentar obtener el histÃ³rico de diferentes fuentes
      let historicoFinal = [];
      let muestraConHistorico = muestra;
      
      // PASO 1: Buscar en muestrasEscaneadas por idMuestraXAnalisis o idOrdenMedica
      const muestraEscaneada = muestrasEscaneadas.find(m => 
        m.idMuestraXAnalisis === muestra.idMuestraXAnalisis ||
        (m.idOrdenMedica && m.idOrdenMedica === muestra.idOrdenMedica && 
         m.descripcionMuestra === muestra.descripcionMuestra)
      );
      
      if (muestraEscaneada) {
        console.log('Muestra encontrada en muestrasEscaneadas:', muestraEscaneada);
        muestraConHistorico = muestraEscaneada;
        
        // OpciÃ³n 1: usar historicoCompleto si existe (objeto agrupado)
        if (muestraEscaneada.historicoCompleto && muestraEscaneada.historicoCompleto.length > 0) {
          historicoFinal = muestraEscaneada.historicoCompleto;
          console.log('Usando historicoCompleto:', historicoFinal.length, 'registros');
        }
        // OpciÃ³n 2: usar histÃ³rico directo del objeto
        else if (muestraEscaneada.historico) {
          if (muestraEscaneada.historico.$values && Array.isArray(muestraEscaneada.historico.$values)) {
            historicoFinal = muestraEscaneada.historico.$values;
          } else if (Array.isArray(muestraEscaneada.historico)) {
            historicoFinal = muestraEscaneada.historico;
          }
          console.log('Usando historico:', historicoFinal.length, 'registros');
        }
        // OpciÃ³n 3: extraer de cada examen individual
        else if (muestraEscaneada.examenes && Array.isArray(muestraEscaneada.examenes) && muestraEscaneada.examenes.length > 0) {
          console.log('Buscando en examenes:', muestraEscaneada.examenes.length);
          muestraEscaneada.examenes.forEach((examen) => {
            if (examen.historico) {
              let historicoExamen = [];
              
              if (examen.historico.$values && Array.isArray(examen.historico.$values)) {
                historicoExamen = examen.historico.$values;
              } else if (Array.isArray(examen.historico)) {
                historicoExamen = examen.historico;
              }
              
              if (historicoExamen.length > 0) {
                historicoFinal.push(...historicoExamen);
              }
            }
          });
          console.log('Histórico extraído de examenes:', historicoFinal.length, 'registros');
        }
      }
      
      // PASO 2: Si viene desde modal de detalle y no se encontrÃ³ en muestrasEscaneadas, usar grupoSeleccionado
      if (historicoFinal.length === 0 && modalDetalleOpen && grupoSeleccionado) {
        console.log('Buscando en grupoSeleccionado (modal de detalle)');
        
        // Si el grupoSeleccionado tiene histÃ³rico
        if (grupoSeleccionado.historico) {
          if (grupoSeleccionado.historico.$values && Array.isArray(grupoSeleccionado.historico.$values)) {
            historicoFinal = grupoSeleccionado.historico.$values;
          } else if (Array.isArray(grupoSeleccionado.historico)) {
            historicoFinal = grupoSeleccionado.historico;
          }
          console.log('Usando histórico de grupoSeleccionado:', historicoFinal.length, 'registros');
        }
        
        // Si grupoSeleccionado tiene examenes, buscar en ellos
        if (historicoFinal.length === 0 && grupoSeleccionado.examenes && Array.isArray(grupoSeleccionado.examenes)) {
          console.log('Buscando en examenes de grupoSeleccionado:', grupoSeleccionado.examenes.length);
          grupoSeleccionado.examenes.forEach((examen) => {
            // Buscar el examen especÃ­fico por idMuestraXAnalisis
            if (examen.idMuestraXAnalisis === muestra.idMuestraXAnalisis && examen.historico) {
              let historicoExamen = [];
              
              if (examen.historico.$values && Array.isArray(examen.historico.$values)) {
                historicoExamen = examen.historico.$values;
              } else if (Array.isArray(examen.historico)) {
                historicoExamen = examen.historico;
              }
              
              if (historicoExamen.length > 0) {
                historicoFinal.push(...historicoExamen);
              }
            }
          });
          console.log('Histórico extraído de examenes de grupoSeleccionado:', historicoFinal.length, 'registros');
        }
      }
      
      // PASO 3: Verificar en el objeto muestra original que se pasÃ³
      if (historicoFinal.length === 0 && muestra.historico) {
        console.log('Usando histórico directo del parámetro muestra');
        if (muestra.historico.$values && Array.isArray(muestra.historico.$values)) {
          historicoFinal = muestra.historico.$values;
        } else if (Array.isArray(muestra.historico)) {
          historicoFinal = muestra.historico;
        }
        console.log('Histórico encontrado en muestra:', historicoFinal.length, 'registros');
      }
      
      // Ordenar por fecha si hay registros
      if (historicoFinal.length > 0) {
        historicoFinal = historicoFinal.sort((a, b) => {
          const fechaA = new Date(a.fecha_cambio_estado || a.fechaCambioEstado || 0);
          const fechaB = new Date(b.fecha_cambio_estado || b.fechaCambioEstado || 0);
          return fechaB - fechaA;
        });
      }
      
      // PASO 4: Si no hay histÃ³rico local, intentar obtenerlo del backend
      if (historicoFinal.length === 0 && muestra.idMuestraXAnalisis) {
        console.log('Consultando histórico desde backend para muestra:', muestra.idMuestraXAnalisis);
        
        try {
          const response = await fetch(`${server}/mg_historico_estados_muestras/muestra/${muestra.idMuestraXAnalisis}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': key,
            }
          });
          
          if (response.ok) {
            const data = await response.json();
            const historicoData = data.$values || data || [];
            
            if (historicoData.length > 0) {
              console.log('Histórico obtenido del backend:', historicoData.length, 'registros');
              
              // Ordenar por fecha (mÃ¡s reciente primero)
              historicoFinal = historicoData.sort((a, b) => {
                const fechaA = new Date(a.fecha_cambio_estado || a.fechaCambioEstado || 0);
                const fechaB = new Date(b.fecha_cambio_estado || b.fechaCambioEstado || 0);
                return fechaB - fechaA;
              });
              
              // Actualizar la muestra en muestrasEscaneadas con el histÃ³rico
              setMuestrasEscaneadas(prev => 
                prev.map(m => 
                  m.idMuestraXAnalisis === muestra.idMuestraXAnalisis 
                    ? { ...m, historico: historicoFinal }
                    : m
                )
              );
            } else {
              console.warn('El backend devolvió respuesta OK pero sin datos de histórico');
            }
          } else {
            console.warn('Error al consultar histórico del backend:', response.status, response.statusText);
          }
        } catch (error) {
          console.warn('No se pudo obtener el histórico del backend:', error);
        }
      }
      
      // Preparar objeto para el modal
      const muestraParaModal = {
        ...muestraConHistorico,
        historico: historicoFinal,
        descripcionMuestra: muestraConHistorico.descripcionMuestra || muestra.descripcionMuestra || 'N/A',
        modulo: muestraConHistorico.modulo || muestra.modulo || 'N/A'
      };
      
      setGrupoSeleccionado(muestraParaModal);
      setModalHistoricoOpen(true);
      
      // Debug: Verificar que los comentarios estÃ¡n llegando
      console.log('Histórico cargado para modal:', historicoFinal.length, 'registros');
      if (historicoFinal.length > 0) {
        console.log('Comentarios en histórico:', historicoFinal.map(h => ({
          fecha: h.fecha_cambio_estado || h.fechaCambioEstado,
          comentario: h.comentario,
          estado_anterior: h.estadoAnterior || h.estado_anterior,
          estado_nuevo: h.estadoNuevo || h.estado_nuevo
        })));
      } else {
        console.warn(' No hay histórico disponible para esta muestra después de todas las búsquedas');
        
        // Mostrar alerta al usuario
        Swal.fire({
          title: 'Sin histórico',
          text: 'Esta muestra no tiene cambios de estado registrados aún',
          icon: 'info',
          timer: 3000,
          showConfirmButton: false
        });
      }
    } catch (error) {
      console.error('Error al procesar histórico:', error);
      
      setGrupoSeleccionado({
        ...muestra,
        historico: []
      });
      
      setModalHistoricoOpen(true);
    }
  };
  
  // FunciÃ³n para manejar la expansiÃ³n de observaciones
  const toggleObservacionExpandida = (index) => {
    setObservacionesExpandidas(prev => {
      const nuevas = new Set(prev);
      if (nuevas.has(index)) {
        nuevas.delete(index);
      } else {
        nuevas.add(index);
      }
      return nuevas;
    });
  };
  
  // FunciÃ³n para obtener observaciÃ³n de una muestra
  const getObservacionMuestra = (muestraIndex) => {
    const observacionManual = observacionesMuestras.get(muestraIndex);
    if (observacionManual) {
      return observacionManual;
    }
    
    const muestra = muestrasEscaneadas[muestraIndex];
    if (muestra && muestra.historicoCompleto && muestra.historicoCompleto.length > 0) {
      const ultimoComentario = muestra.historicoCompleto.find(h => h.comentario && h.comentario.trim());
      if (ultimoComentario) {
        return ultimoComentario.comentario.trim();
      }
    }
    
    return '';
  };
  
  // FunciÃ³n para guardar observaciÃ³n en el histÃ³rico
  const guardarObservacionHistorico = async (muestraIndex, textoObservacion) => {
    try {
      if (!textoObservacion || !textoObservacion.trim()) {
        console.log('No hay observación para guardar');
        return false;
      }

      const muestra = muestrasEscaneadas[muestraIndex];
      if (!muestra) {
        console.error('No se encontró la muestra');
        return false;
      }

      console.log('Guardando observación para muestra:', muestra.descripcionMuestra);
      
      // AquÃ­ deberÃ­as implementar la llamada a la API para guardar la observaciÃ³n
      // Por ahora, actualizar localmente
      setObservacionesMuestras(prev => {
        const nuevas = new Map(prev);
        nuevas.set(muestraIndex, textoObservacion.trim());
        return nuevas;
      });
      
      return true;
    } catch (error) {
      console.error('Error al guardar observación:', error);
      throw error;
    }
  };
  
  // Componente para el campo de observaciones
  const ObservacionesCompactas = ({ index, observacion, placeholder }) => {
    const estaExpandida = observacionesExpandidas.has(index);
    const tieneContenido = observacion && observacion.trim();
    
    const muestra = muestrasEscaneadas[index];
    const esMuestraNoConforme = muestra && (muestra.estadoActual === 9);
    
    if (!estaExpandida) {
      return (
        <IconButton
          size="small"
          onClick={() => toggleObservacionExpandida(index)}
          sx={{ 
            padding: '6px',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
            color: esMuestraNoConforme ? (tieneContenido ? '#d32f2f' : '#ff9800') : (tieneContenido ? '#1976d2' : '#999')
          }}
          title={tieneContenido ? 'Ver/editar observaciones' : 'Agregar observaciones'}
        >
          {esMuestraNoConforme ? (
            <MuestraNoConformeIcon sx={{ fontSize: '1.2rem' }} />
          ) : tieneContenido ? (
            <CommentIcon sx={{ fontSize: '1.2rem' }} />
          ) : (
            <CommentOutlinedIcon sx={{ fontSize: '1.2rem' }} />
          )}
        </IconButton>
      );
    }

    return (
      <>
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1300
          }}
          onClick={() => toggleObservacionExpandida(index)}
        />
        <Box sx={{ 
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '500px',
          maxHeight: '400px',
          backgroundColor: 'white',
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
          zIndex: 1301
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Observaciones</Typography>
            <IconButton
              size="small"
              onClick={() => toggleObservacionExpandida(index)}
              sx={{ '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }}
            >
              <ExpandLessIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            multiline
            rows={4}
            defaultValue={observacionesMuestras.get(index) || observacion || ''}
            placeholder={placeholder}
            inputRef={(el) => {
              if (el) {
                textareaRefs.current.set(index, el);
              }
            }}
            autoFocus
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => toggleObservacionExpandida(index)}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={async () => {
                const textarea = textareaRefs.current.get(index);
                const textoObservacion = textarea ? textarea.value.trim() : '';
                
                const nuevasExpandidas = new Set(observacionesExpandidas);
                nuevasExpandidas.delete(index);
                setObservacionesExpandidas(nuevasExpandidas);
                
                if (textoObservacion) {
                  guardarObservacionHistorico(index, textoObservacion)
                    .then(() => {
                      Swal.fire({
                        icon: 'success',
                        title: 'Guardado',
                        text: 'Observación guardada correctamente',
                        timer: 1500,
                        showConfirmButton: false
                      });
                    })
                    .catch(error => {
                      console.error('Error al guardar:', error);
                      Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo guardar la observación',
                        timer: 2000,
                        showConfirmButton: false
                      });
                    });
                }
              }}
            >
              Guardar
            </Button>
          </Box>
        </Box>
      </>
    );
  };
  
  // FunciÃ³n para limpiar formulario
  const limpiarFormulario = () => {
    setMuestrasEscaneadas([]);
    setMuestrasSeleccionadas([]);
    setMuestrasSeleccionadasMasivas([]);
    setCodigoBarra('');
    setTablePage(0);
    setObservacionesMuestras(new Map());
    setObservacionesExpandidas(new Set());
    
    // Actualizar fecha y hora actual para el prÃ³ximo escaneo
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    setFechaTraslado(`${year}-${month}-${day}T${hours}:${minutes}`);
    
    setAccionesRealizadas({
      muestrasModificadas: 0,
      etiquetasImpresas: 0,
      cambiosEstado: [],
      fechaInicio: new Date()
    });
  };

  // FunciÃ³n para guardar cambios
  const handleGuardarFormulario = async () => {
    if (muestrasEscaneadas.length === 0) {
      Swal.fire('Información', 'No hay cambios para guardar', 'info');
      return;
    }

    setGuardandoFormulario(true);
    
    try {
      // AquÃ­ implementarÃ­as la lÃ³gica de guardado
      // Por ahora, simular guardado exitoso
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const resumen = `
        Muestras procesadas: ${muestrasEscaneadas.length}
        Cambios de estado: ${accionesRealizadas.cambiosEstado.length}
        Etiquetas impresas: ${accionesRealizadas.etiquetasImpresas}
      `;

      Swal.fire({
        title: 'Guardado exitoso',
        html: resumen.replace(/\n/g, '<br>'),
        icon: 'success',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        limpiarFormulario();
      });

    } catch (error) {
      console.error('Error al guardar:', error);
      Swal.fire('Error', 'No se pudieron guardar los cambios', 'error');
    } finally {
      setGuardandoFormulario(false);
    }
  };

  // Efectos
  useEffect(() => {
    // Cargar estados disponibles y usuarios al montar el componente
    fetchEstadosDisponibles();
    fetchUsuariosDisponibles();
  }, []);
  

  
  // Cargar usuarios y condiciones cuando se abre el modal
  useEffect(() => {
    if (openComentarioModal && esCambioDobleEstado) {
      fetchUsuariosDisponibles();
    }
    if (openComentarioModal && pendingCambioEstado?.nuevoEstadoId === 9) {
      fetchCondicionesMuestra();
    }
  }, [openComentarioModal, esCambioDobleEstado, pendingCambioEstado]);

  // Auto-focus del input de cÃ³digo de barra despuÃ©s de cerrar modales
  useEffect(() => {
    if (!openComentarioModal && !modalDetalleOpen && !modalHistoricoOpen && !scanning && !loading) {
      // PequeÃ±o delay para asegurar que el modal se cerrÃ³ completamente
      const timeoutId = setTimeout(() => {
        barcodeInputRef.current?.focus();
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [openComentarioModal, modalDetalleOpen, modalHistoricoOpen, scanning, loading]);

  // Funciones de paginaciÃ³n
  const handleChangeTablePage = (event, newPage) => {
    setTablePage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setTablePage(0);
  };

  // Muestras paginadas
  const muestrasPaginadas = muestrasEscaneadas.slice(
    tablePage * rowsPerPage,
    tablePage * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ 
      p: 3, 
      marginLeft: '230px', // Espacio para el menÃº lateral expandido (nav-md)
      transition: 'margin-left 0.3s ease', // TransiciÃ³n suave
      '@media (max-width: 768px)': {
        marginLeft: 0 // En mÃ³viles, sin margen
      },
      // Ajuste dinÃ¡mico cuando el menÃº se contrae (nav-sm)
      'body.nav-sm &': {
        marginLeft: '70px' // Espacio reducido cuando el menÃº estÃ¡ contraÃ­do
      }
    }}>
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2, 
        mb: 3,
        p: 2,
        backgroundColor: '#0c5280',
        borderRadius: 1,
        boxShadow: 2
      }}>
        <Typography variant="h4" sx={{ color: '#ffffff', fontWeight: 'bold' }}>
          Verificación de Muestras
        </Typography>
        <Tooltip 
          title="Área exclusiva de verificación: Solo se procesarán muestras en estados 'Pendiente', 'Toma Realizada', 'Recepción en Ventanilla' o 'Verificada'. Las muestras escaneadas se seleccionan automáticamente para agilizar el proceso de verificación."
          arrow
          placement="right"
        >
          <IconButton size="small" sx={{ color: '#ffffff' }}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>



      {/* InformaciÃ³n de contexto */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <Typography variant="body2" color="textSecondary">
                <strong>Usuario:</strong> {user?.codigoUsuario || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <Typography variant="body2" color="textSecondary">
                <strong>Sucursal:</strong> {sucursalSeleccionada?.nombreSucursal || 'N/A'}
              </Typography>
            </Grid>

          </Grid>
          
          {/* Controles de Verificación */}
          <Divider sx={{ my: 2 }} />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <Autocomplete
                options={usuariosDisponibles}
                getOptionLabel={(option) => `${option.nombreCompleto || ''} (${option.codigoUsuario || ''})`}
                value={usuariosDisponibles.find(u => u.codigoUsuario === usuarioTraslado) || null}
                onChange={(event, newValue) => {
                  setUsuarioTraslado(newValue?.codigoUsuario || '');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Usuario que traslada"
                    placeholder="Seleccione quien traslada"
                    size="small"
                    disabled={cargandoUsuarios}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {cargandoUsuarios ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Fecha y hora del traslado"
                type="datetime-local"
                value={fechaTraslado}
                onChange={(e) => setFechaTraslado(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Autocomplete
                options={usuariosDisponibles}
                getOptionLabel={(option) => `${option.nombreCompleto || ''} (${option.codigoUsuario || ''})`}
                value={usuariosDisponibles.find(u => u.codigoUsuario === usuarioVerifica) || null}
                onChange={(event, newValue) => {
                  setUsuarioVerifica(newValue?.codigoUsuario || '');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Usuario que verifica"
                    placeholder="Seleccione quien verifica"
                    size="small"
                    disabled={cargandoUsuarios}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {cargandoUsuarios ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* SecciÃ³n de escaneo */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Escanear Código de Muestra
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Código de Barra de Muestra"
                value={codigoBarra}
                onChange={(e) => setCodigoBarra(e.target.value.toUpperCase())}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleEscanearMuestra(codigoBarra);
                  }
                }}
                placeholder="Escanee o escriba el código de barra de la muestra"
                disabled={loading || !cubiculoSeleccionado || !tienePermiso('Acciones Toma Muestra')}
                inputRef={barcodeInputRef}
                InputProps={{
                  endAdornment: loading && <CircularProgress size={20} />
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => handleEscanearMuestra(codigoBarra)}
                disabled={loading || !cubiculoSeleccionado || !tienePermiso('Acciones Toma Muestra')}
                startIcon={<ScanIcon />}
              >
                Escanear
              </Button>
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                fullWidth
                variant="contained"
                color={scanning ? "error" : "info"}
                onClick={() => setScanning(!scanning)}
                disabled={loading || !cubiculoSeleccionado || !tienePermiso('Acciones Toma Muestra')}
                startIcon={scanning ? <StopIcon /> : <CameraAltIcon />}
              >
                {scanning ? 'Detener' : 'Cámara'}
              </Button>
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                onClick={limpiarFormulario}
                startIcon={<ClearIcon />}
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Componente de escaneo con cÃ¡mara */}
      {scanning && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                Escaneo con Cámara
              </Typography>
              <Button 
                variant="contained" 
                color="error" 
                size="small"
                onClick={() => setScanning(false)}
                startIcon={<StopIcon />}
              >
                Detener Cámara
              </Button>
            </Box>
            <BarcodeScannerComponent
              width="100%"
              height={400}
              onUpdate={(err, result) => {
                if (result) {
                  const codigoMayusculas = result.text.toUpperCase();
                  setCodigoBarra(codigoMayusculas);
                  handleEscanearMuestra(codigoMayusculas);
                  setScanning(false);
                }
              }}
            />
          </CardContent>
        </Card>
      )}

      {/* Tabla de muestras escaneadas */}
      {muestrasEscaneadas.length > 0 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                Muestras Escaneadas ({muestrasEscaneadas.length})
              </Typography>
            </Box>

            {/* SecciÃ³n de Acciones Masivas */}
            {muestrasEscaneadas.length > 0 && muestrasSeleccionadasMasivas.length > 0 && (() => {
                  const estadoSiguiente = obtenerEstadoSiguienteMasivo();
                  // Validación eliminada: permitir procesar análisis con diferentes estados
                  
                  // Solo mostrar el box si hay opciones disponibles
                  if (!estadoSiguiente || estadoSiguiente.opciones.length === 0) {
                    return null;
                  }
                  
                  return (
                    <Box sx={{ mb: 3, p: 2, bgcolor: '#e3f2fd', borderRadius: 2, border: '2px solid #1976d2' }}>
                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                          {estadoSiguiente.opciones.map((opcion) => (
                            <Button
                              key={opcion.id}
                              variant={opcion.isPrimary ? "contained" : "outlined"}
                              color={getEstadoButtonColor(opcion.id)}
                              onClick={() => handleAccionMasiva(opcion)}
                              disabled={procesandoAccionMasiva || !tienePermiso('Acciones Toma Muestra')}
                              startIcon={procesandoAccionMasiva ? <CircularProgress size={16} color="inherit" /> : getEstadoIcon(opcion.id)}
                              sx={{
                                minWidth: '180px',
                                fontSize: '0.95rem',
                                fontWeight: 'bold',
                                py: 1.5
                              }}
                            >
                              {opcion.estado} ({muestrasSeleccionadasMasivas.length})
                            </Button>
                          ))}
                          
                          <Button
                            variant="text"
                            color="secondary"
                            onClick={() => setMuestrasSeleccionadasMasivas([])}
                            startIcon={<ClearIcon />}
                            sx={{ ml: 1 }}
                          >
                            Limpiar Selección
                          </Button>
                      </Box>
                    </Box>
                  );
                })()}

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={muestrasSeleccionadasMasivas.length === muestrasPaginadas.length && muestrasPaginadas.length > 0}
                        indeterminate={muestrasSeleccionadasMasivas.length > 0 && muestrasSeleccionadasMasivas.length < muestrasPaginadas.length}
                        onChange={(e) => {
                          const startIndex = tablePage * rowsPerPage;
                          const indices = muestrasPaginadas.map((_, index) => startIndex + index);
                          if (e.target.checked) {
                            setMuestrasSeleccionadasMasivas(prev => [...new Set([...prev, ...indices])]);
                          } else {
                            setMuestrasSeleccionadasMasivas(prev => prev.filter(i => !indices.includes(i)));
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>Orden</TableCell>
                    <TableCell>Paciente</TableCell>
                    <TableCell>Módulo</TableCell>
                    <TableCell>Muestra</TableCell>
                    <TableCell>Cantidad</TableCell>
                    <TableCell>Exámenes</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Detalle</TableCell>
                    <TableCell>Obs.</TableCell>
                    <TableCell>Acciones</TableCell>
                    <TableCell>Hora Escaneo</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {muestrasPaginadas.map((muestra, index) => {
                    const realIndex = tablePage * rowsPerPage + index;
                    const isSelected = muestrasSeleccionadasMasivas.includes(realIndex);
                    const cantidadAnalisis = (muestra.idsMuestrasXAnalisis || [muestra.idMuestraXAnalisis]).length;
                    const estaVerificada = muestra.estadoActual === 3; // Estado 3 = Verificada
                    
                    return (
                      <TableRow 
                        key={`${muestra.idMuestraXAnalisis}-${index}`} 
                        selected={isSelected}
                        sx={{ 
                          '& .MuiTableCell-root': { padding: '4px 8px', fontSize: '0.8rem' },
                          backgroundColor: estaVerificada ? 'rgba(76, 175, 80, 0.1)' : 'inherit',
                          '&:hover': {
                            backgroundColor: estaVerificada ? 'rgba(76, 175, 80, 0.2)' : 'rgba(0, 0, 0, 0.04)'
                          }
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            size="small"
                            checked={isSelected}
                            onChange={(e) => handleSeleccionMasivaChange(realIndex, e.target.checked)}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.8rem' }}>
                            {muestra.numeroOrden || 'N/A'}
                          </Typography>
                        </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                          {muestra.nombrePaciente || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={muestra.modulo || 'N/A'} 
                          size="small" 
                          color="primary" 
                          variant="outlined"
                          sx={{ height: '20px', fontSize: '0.7rem' }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                          {muestra.descripcionMuestra || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                          {muestra.descripcionCantidad || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          {cantidadAnalisis > 1 && (
                            <Chip 
                              label={cantidadAnalisis}
                              size="small"
                              color={estaVerificada ? "success" : "secondary"}
                              sx={{ 
                                height: '18px', 
                                fontSize: '0.65rem', 
                                minWidth: '24px',
                                fontWeight: estaVerificada ? 'bold' : 'normal'
                              }}
                            />
                          )}
                          {estaVerificada && (
                            <CheckCircle sx={{ fontSize: '1rem', color: '#4caf50' }} />
                          )}
                          <Tooltip 
                            title={
                              muestra.examenes && Array.isArray(muestra.examenes) && muestra.examenes.length > 0
                                ? muestra.examenes.map(e => e.analisis || e.nombreAnalisis).filter(Boolean).join(', ')
                                : (muestra.analisis || muestra.nombreAnalisis || 'Sin anÃ¡lisis')
                            } 
                            arrow
                          >
                            <Typography 
                              variant="body2" 
                              sx={{ 
                                maxWidth: '150px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                cursor: 'pointer',
                                fontSize: '0.8rem'
                              }}
                            >
                              {muestra.examenes && Array.isArray(muestra.examenes) && muestra.examenes.length > 0
                                ? muestra.examenes.map(e => e.analisis || e.nombreAnalisis).filter(Boolean).join(', ')
                                : (muestra.analisis || muestra.nombreAnalisis || 'N/A')
                              }
                            </Typography>
                          </Tooltip>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={getEstadoDescription(muestra.estadoActual || 1)}
                          style={{ 
                            backgroundColor: getEstadoColor(muestra.estadoActual || 1),
                            color: 'white',
                            fontSize: '0.65rem',
                            height: '22px',
                            fontWeight: estaVerificada ? 'bold' : 'normal',
                            boxShadow: estaVerificada ? '0 0 8px rgba(76, 175, 80, 0.5)' : 'none'
                          }}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Ver detalle" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleAbrirDetalleModal(muestra, realIndex)}
                            sx={{ padding: '4px' }}
                            disabled={!tienePermiso('Acciones Toma Muestra')}
                          >
                            <ViewIcon sx={{ fontSize: '1rem' }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <ObservacionesCompactas
                          index={realIndex}
                          observacion={getObservacionMuestra(realIndex)}
                          placeholder="Agregar observaciones para esta muestra..."
                        />
                      </TableCell>
                      <TableCell>
                        <AccionesDropdown
                          estadoActual={muestra.estadoActual || 1}
                          estadosDisponibles={estadosDisponibles}
                          onCambiarEstado={(nuevoEstado) => 
                            handleCambiarEstadoMuestra(realIndex, nuevoEstado)
                          }
                          getEstadoIcon={getEstadoIcon}
                          getEstadoButtonColor={getEstadoButtonColor}
                          getSiguienteEstado={getSiguienteEstado}
                          isLoading={muestrasIndividualesCargando.has(`${realIndex}-${muestra.idMuestraXAnalisis}`)}
                          puedeReactivarMuestraNoConforme={true}
                          enModalDetalle={false}
                          disabled={!tienePermiso('Acciones Toma Muestra')}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                          {new Date(muestra.fechaEscaneo).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      colSpan={11}
                      count={muestrasEscaneadas.length}
                      rowsPerPage={rowsPerPage}
                      page={tablePage}
                      onPageChange={handleChangeTablePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* Modal de impresión de etiquetas */}
      <Dialog 
        open={imprimirEtiquetasOpen} 
        onClose={handleCerrarImprimirEtiquetas}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Seleccionar Muestras para Etiquetas</DialogTitle>
        <DialogContent>
          <FormControlLabel
            control={
              <Checkbox
                checked={muestrasSeleccionadas.length === muestrasEscaneadas.length && muestrasEscaneadas.length > 0}
                indeterminate={muestrasSeleccionadas.length > 0 && muestrasSeleccionadas.length < muestrasEscaneadas.length}
                onChange={(e) => handleSeleccionarTodasMuestras(e.target.checked)}
              />
            }
            label="Seleccionar todas las muestras"
          />
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Seleccionar</TableCell>
                  <TableCell>Módulo</TableCell>
                  <TableCell>Descripción</TableCell>
                  <TableCell>Cant.</TableCell>
                  <TableCell>Exámenes</TableCell>
                  <TableCell>Cobas 303</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(() => {
                  const muestrasAgrupadas = agruparMuestrasParaEtiquetas(muestrasEscaneadas);
                  return muestrasAgrupadas.map((grupo, groupIndex) => (
                    <TableRow key={groupIndex}>
                      <TableCell>
                        <Checkbox
                          checked={grupo.examenes.every(m => muestrasSeleccionadas.includes(m.idMuestraXAnalisis))}
                          indeterminate={
                            grupo.examenes.some(m => muestrasSeleccionadas.includes(m.idMuestraXAnalisis)) &&
                            !grupo.examenes.every(m => muestrasSeleccionadas.includes(m.idMuestraXAnalisis))
                          }
                          onChange={(e) => {
                            const checked = e.target.checked;
                            if (checked) {
                              // Seleccionar todos los exÃ¡menes del grupo
                              const nuevasSeleccionadas = [...new Set([...muestrasSeleccionadas, ...grupo.examenes.map(m => m.idMuestraXAnalisis)])];
                              setMuestrasSeleccionadas(nuevasSeleccionadas);
                            } else {
                              // Deseleccionar todos los exÃ¡menes del grupo
                              const idsGrupo = grupo.examenes.map(m => m.idMuestraXAnalisis);
                              setMuestrasSeleccionadas(prev => prev.filter(id => !idsGrupo.includes(id)));
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>{grupo.modulo}</TableCell>
                      <TableCell>{grupo.descripcionMuestra}</TableCell>
                      <TableCell>{grupo.descripcionCantidad}</TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>
                            {grupo.analisisTexto}
                          </Typography>
                          {/* Mostrar checkboxes individuales para cada anÃ¡lisis */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {grupo.examenes.map((examen, exIndex) => (
                              <FormControlLabel
                                key={exIndex}
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={muestrasSeleccionadas.includes(examen.idMuestraXAnalisis)}
                                    onChange={(e) => handleMuestraSeleccionChange(examen.idMuestraXAnalisis, e.target.checked)}
                                  />
                                }
                                label={
                                  <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                                    {examen.analisis || examen.nombreAnalisis || 'Análisis'}
                                  </Typography>
                                }
                              />
                            ))}
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={grupo.esCobas303 || false}
                          onChange={(e) => {
                            // Actualizar todos los exÃ¡menes del grupo
                            const updatedSamples = [...muestrasEscaneadas];
                            grupo.examenes.forEach(examen => {
                              const index = updatedSamples.findIndex(m => m.idMuestraXAnalisis === examen.idMuestraXAnalisis);
                              if (index !== -1) {
                                updatedSamples[index] = {
                                  ...updatedSamples[index],
                                  esCobas303: e.target.checked
                                };
                              }
                            });
                            setMuestrasEscaneadas(updatedSamples);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ));
                })()}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCerrarImprimirEtiquetas} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleImprimirEtiquetas} color="primary" variant="contained">
            Imprimir Etiquetas
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de preview de etiquetas */}
      <Dialog
        open={openEtiquetasPreview}
        onClose={() => setOpenEtiquetasPreview(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { height: '90vh' }
        }}
      >
        <DialogTitle>
          Vista Previa de Etiquetas
          <IconButton
            onClick={() => setOpenEtiquetasPreview(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          {etiquetasPdfUrl && (
            <iframe
              src={etiquetasPdfUrl}
              width="100%"
              height="100%"
              title="Vista Previa de Etiquetas"
              style={{ border: 'none' }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              if (etiquetasPdfUrl) {
                const link = document.createElement('a');
                link.href = etiquetasPdfUrl;
                link.download = 'etiquetas.pdf';
                link.click();
              }
            }} 
            color="primary"
            variant="contained"
            startIcon={<PrintIcon />}
          >
            Descargar PDF
          </Button>
        </DialogActions>
      </Dialog>



      {/* Modal de comentarios para acciones masivas y cambio doble */}
      <Dialog
        open={openComentarioModal}
        onClose={() => {
          if (!procesandoAccionMasiva && !muestrasIndividualesCargando.size) {
            setOpenComentarioModal(false);
            setPendingCambioEstado(null);
            setComentarioTexto('');
            setCondicionMuestraSeleccionada('');
            setUsuarioTraslado('');
            setUsuarioVerifica('');
            setFechaTraslado('');
          }
        }}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown={procesandoAccionMasiva || muestrasIndividualesCargando.size > 0}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {pendingCambioEstado?.esCambioDoble ? (
              <>
                <ReceivedIcon color="primary" />
                Cambio Doble: TRASLADAR/VERIFICAR
              </>
            ) : pendingCambioEstado?.esMuestraRepetida ? (
              <>
                <WarningIcon color="warning" />
                Muestra Repetida
              </>
            ) : pendingCambioEstado?.nuevoEstadoId === 9 ? (
              <>
                <MuestraNoConformeIcon color="error" />
                Muestra No Conforme
              </>
            ) : (
              <>
                <WarningIcon color="warning" />
                Agregar Comentario
              </>
            )}
          </Box>
        </DialogTitle>
        <DialogContent>
          {pendingCambioEstado && (
            <>
              {/* Campos especiales para cambio doble (TRASLADAR/VERIFICAR) */}
              {pendingCambioEstado.esCambioDoble && (
                <Box sx={{ mb: 3 }}>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    Complete la información del traslado y verificación de muestras:
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={usuariosDisponibles}
                        getOptionLabel={(option) => `${option.nombreCompleto || ''} (${option.codigoUsuario || ''})`}
                        value={usuariosDisponibles.find(u => u.codigoUsuario === usuarioTraslado) || null}
                        onChange={(event, newValue) => {
                          setUsuarioTraslado(newValue?.codigoUsuario || '');
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Usuario que traslada (requerido)"
                            placeholder="Seleccione quien trasladó la muestra"
                            required
                            disabled={cargandoUsuarios}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {cargandoUsuarios ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        disabled={procesandoAccionMasiva}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Fecha y hora del traslado (requerido)"
                        type="datetime-local"
                        value={fechaTraslado}
                        onChange={(e) => setFechaTraslado(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        disabled={procesandoAccionMasiva}
                        helperText="Registre cuándo se trasladó la muestra"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={usuariosDisponibles}
                        getOptionLabel={(option) => `${option.nombreCompleto || ''} (${option.codigoUsuario || ''})`}
                        value={usuariosDisponibles.find(u => u.codigoUsuario === usuarioVerifica) || null}
                        onChange={(event, newValue) => {
                          setUsuarioVerifica(newValue?.codigoUsuario || '');
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Usuario que verifica (requerido)"
                            placeholder="Seleccione quien verifica la muestra"
                            required
                            disabled={cargandoUsuarios}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {cargandoUsuarios ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        disabled={procesandoAccionMasiva}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Selector de condición de muestra para Muestra No Conforme */}
              {pendingCambioEstado.nuevoEstadoId === 9 && (
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Condición de Muestra No Conforme (requerido)</InputLabel>
                  <Select
                    value={condicionMuestraSeleccionada}
                    onChange={(e) => setCondicionMuestraSeleccionada(e.target.value)}
                    label="Condición de Muestra No Conforme (requerido)"
                    disabled={procesandoAccionMasiva || cargandoCondicionesMuestra}
                  >
                    {cargandoCondicionesMuestra ? (
                      <MenuItem disabled>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                        Cargando condiciones...
                      </MenuItem>
                    ) : (
                      condicionesMuestra.map((condicion) => (
                        <MenuItem key={condicion.id} value={condicion.id}>
                          {condicion.descripcion}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              )}

              {/* Campos para Muestra Repetida */}
              {pendingCambioEstado.esMuestraRepetida && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    Indique el motivo de la repetición y asigne un responsable:
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Motivo de Muestra Repetida (requerido)</InputLabel>
                    <Select
                      value={motivoRepetidaSeleccionado}
                      onChange={(e) => setMotivoRepetidaSeleccionado(e.target.value)}
                      label="Motivo de Muestra Repetida (requerido)"
                      disabled={procesandoAccionMasiva || cargandoMotivosRepetida}
                    >
                      {cargandoMotivosRepetida ? (
                        <MenuItem disabled>
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          Cargando motivos...
                        </MenuItem>
                      ) : (
                        motivosRepetida.map((motivo) => (
                          <MenuItem key={motivo.id} value={motivo.id}>
                            {motivo.descripcion}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                  <Autocomplete
                    options={usuariosDisponibles}
                    getOptionLabel={(option) => `${option.nombreCompleto || ''} (${option.codigoUsuario || ''})`}
                    value={usuariosDisponibles.find(u => u.codigoUsuario === responsableRepetida) || null}
                    onChange={(event, newValue) => {
                      setResponsableRepetida(newValue?.codigoUsuario || '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Responsable asignado (requerido)"
                        placeholder="Seleccione el responsable"
                        required
                        disabled={cargandoUsuarios}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {cargandoUsuarios ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    disabled={procesandoAccionMasiva}
                    sx={{ mb: 2 }}
                  />
                </Box>
              )}

              {/* Campo de comentario */}
              {!pendingCambioEstado.esCambioDoble && (
                <TextField
                  fullWidth
                  label={pendingCambioEstado.nuevoEstadoId === 9 ? "Comentario adicional (requerido)" : "Comentario (requerido)"}
                  multiline
                  rows={4}
                  value={comentarioTexto}
                  onChange={(e) => setComentarioTexto(e.target.value)}
                  placeholder={
                    pendingCambioEstado.nuevoEstadoId === 9 
                      ? "Describa el motivo de la no conformidad..." 
                      : "Ingrese un comentario para esta acción..."
                  }
                  disabled={procesandoAccionMasiva}
                  autoFocus={!pendingCambioEstado.esCambioDoble}
                  sx={{ mt: 1 }}
                  required
                />
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setOpenComentarioModal(false);
              setPendingCambioEstado(null);
              setComentarioTexto('');
              setCondicionMuestraSeleccionada('');
              setUsuarioTraslado('');
              setFechaTraslado('');
              setMotivoRepetidaSeleccionado('');
              setResponsableRepetida('');
            }}
            color="secondary"
            disabled={procesandoAccionMasiva || muestrasIndividualesCargando.size > 0}
          >
            Cancelar
          </Button>
          <Button 
            onClick={async () => {
              // Validar campos según el tipo de acción
              if (pendingCambioEstado?.esCambioDoble) {
                if (!usuarioTraslado.trim()) {
                  Swal.fire('Error', 'Debe seleccionar el usuario que traslada', 'error');
                  return;
                }
                if (!usuarioVerifica.trim()) {
                  Swal.fire('Error', 'Debe seleccionar el usuario que verifica', 'error');
                  return;
                }
                if (!fechaTraslado.trim()) {
                  Swal.fire('Error', 'Debe ingresar la fecha y hora del traslado', 'error');
                  return;
                }
                // Para cambio doble, llamar a la función especial
                await procesarCambioEstadoDoble('Muestra verificada en recepción', usuarioTraslado, usuarioVerifica, fechaTraslado);
              } else if (pendingCambioEstado?.esMuestraRepetida) {
                // Validar campos de Muestra Repetida
                if (!motivoRepetidaSeleccionado) {
                  Swal.fire('Error', 'Debe seleccionar un motivo de muestra repetida', 'error');
                  return;
                }
                if (!responsableRepetida.trim()) {
                  Swal.fire('Error', 'Debe seleccionar un responsable', 'error');
                  return;
                }
                
                // Construir comentario con motivo y responsable
                const motivoObj = motivosRepetida.find(m => m.id === parseInt(motivoRepetidaSeleccionado));
                const motivoDesc = motivoObj ? motivoObj.descripcion : 'Motivo no especificado';
                let comentarioFinal = `MOTIVO MUESTRA REPETIDA: ${motivoDesc}\nRESPONSABLE: ${responsableRepetida}`;
                if (comentarioTexto.trim()) {
                  comentarioFinal += `\n${comentarioTexto.trim()}`;
                }
                
                try {
                  // 1. Cambiar a estado Muestra Repetida
                  if (pendingCambioEstado.isIndividual) {
                    await procesarCambioEstadoIndividualConComentario(comentarioFinal);
                  } else {
                    await procesarAccionMasivaConComentario(comentarioFinal);
                  }
                  
                  // 2. Reiniciar automáticamente a Pendiente
                  const estadoPendiente = estadosDisponibles.find(e => e.estado === 'Pendiente');
                  const estadoMuestraRepetida = estadosDisponibles.find(e => e.estado === 'Muestra Repetida');
                  if (estadoPendiente && estadoMuestraRepetida) {
                    const muestrasAfectadas = pendingCambioEstado.isIndividual ? 
                      [pendingCambioEstado.muestra] : 
                      pendingCambioEstado.muestrasAfectadas;
                    
                    for (const muestra of muestrasAfectadas) {
                      const examenes = Array.isArray(muestra.examenes) ? muestra.examenes : [muestra];
                      for (const examen of examenes) {
                        const requestData = {
                          IdOrden: examen.idOrdenMedica || pendingCambioEstado.muestra?.idOrdenMedica,
                          IdMuestraXAnalisis: examen.idMuestraXAnalisis,
                          EstadoAnterior: estadoMuestraRepetida.id,
                          NuevoEstado: estadoPendiente.id,
                          UsuarioId: user ? user.codigoUsuario : 'ADMIN',
                          Comentario: 'Reinicio automático desde Muestra Repetida',
                          IdSucursal: null,
                          Cubiculo: null
                        };
                        
                        await fetch(`${server}/mg_muestras_x_ordens/cambiarestado`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            'x-api-key': key,
                          },
                          body: JSON.stringify(requestData),
                        });
                      }
                    }
                    // Actualizar estado local a Pendiente después del reset
                    const estadoPendienteId = estadoPendiente.id;
                    if (pendingCambioEstado.isIndividual) {
                      setMuestrasEscaneadas(prev => 
                        prev.map((m, idx) => 
                          idx === pendingCambioEstado.muestraIndex 
                            ? { ...m, estadoActual: estadoPendienteId }
                            : m
                        )
                      );
                    } else {
                      const indicesAfectados = new Set(pendingCambioEstado.muestrasIndices);
                      setMuestrasEscaneadas(prev => 
                        prev.map((m, idx) => 
                          indicesAfectados.has(idx) 
                            ? { ...m, estadoActual: estadoPendienteId }
                            : m
                        )
                      );
                    }
                  }
                } catch (error) {
                  console.error('Error en Muestra Repetida:', error);
                  Swal.fire('Error', error.message, 'error');
                }
              } else {
                // Para otros casos, validar comentario
                if (!comentarioTexto.trim() || comentarioTexto.trim().length < 5) {
                  Swal.fire('Error', 'El comentario debe tener al menos 5 caracteres', 'error');
                  return;
                }
                
                // Si es Muestra No Conforme, validar condición seleccionada
                if (pendingCambioEstado?.nuevoEstadoId === 9 && !condicionMuestraSeleccionada) {
                  Swal.fire('Error', 'Debe seleccionar una condición de muestra', 'error');
                  return;
                }
                
                // Construir comentario final con condición si aplica
                let comentarioFinal = comentarioTexto.trim();
                if (pendingCambioEstado?.nuevoEstadoId === 9 && condicionMuestraSeleccionada) {
                  const condicionSeleccionada = condicionesMuestra.find(c => c.id === parseInt(condicionMuestraSeleccionada));
                  const motivoNoConformidad = condicionSeleccionada ? condicionSeleccionada.descripcion : 'Condición no especificada';
                  comentarioFinal = `MOTIVO NO CONFORMIDAD: ${motivoNoConformidad}\n\n${comentarioTexto.trim()}`;
                }
                
                if (pendingCambioEstado.isIndividual) {
                  await procesarCambioEstadoIndividualConComentario(comentarioFinal);
                } else {
                  await procesarAccionMasivaConComentario(comentarioFinal);
                }
              }
              
              // Cerrar modal y limpiar
              setOpenComentarioModal(false);
              setPendingCambioEstado(null);
              setComentarioTexto('');
              setCondicionMuestraSeleccionada('');
              setUsuarioTraslado('');
              setUsuarioVerifica('');
              setFechaTraslado('');
              setMotivoRepetidaSeleccionado('');
              setResponsableRepetida('');
            }}
            color="primary"
            variant="contained"
            disabled={
              procesandoAccionMasiva || 
              muestrasIndividualesCargando.size > 0 ||
              (pendingCambioEstado?.esCambioDoble ? (!usuarioTraslado || !usuarioVerifica || !fechaTraslado) : 
               pendingCambioEstado?.esMuestraRepetida ? (!motivoRepetidaSeleccionado || !responsableRepetida) :
               (comentarioTexto.trim().length === 0))
            }
            startIcon={(procesandoAccionMasiva || muestrasIndividualesCargando.size > 0) ? <CircularProgress size={16} /> : null}
          >
            {(procesandoAccionMasiva || muestrasIndividualesCargando.size > 0) ? 'Procesando...' : 'Confirmar Acción'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de detalle individual de muestras */}
      <Dialog
        open={modalDetalleOpen}
        onClose={handleCerrarDetalleModal}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { minHeight: '600px' }
        }}
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          backgroundColor: '#1976d2',
          color: 'white',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ViewIcon />
              <Typography variant="h6">
                Detalle Individual: {grupoSeleccionado?.descripcionMuestra || 'Muestra'}
              </Typography>
            </Box>
            <IconButton
              onClick={handleCerrarDetalleModal}
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          
          {/* Barra de acciones masivas en modal de detalle */}
          {muestrasDetalleSeleccionadas.length > 0 && (() => {
            // ValidaciÃ³n eliminada: permitir procesar anÃ¡lisis con diferentes estados
            
            const resultadoEstado = obtenerEstadoSiguienteMasivo();
            
            if (!resultadoEstado || !resultadoEstado.opciones) {
              return null;
            }
            
            const opcionPrimaria = resultadoEstado.opciones.find(op => op.isPrimary);
            const opcionesSecundarias = resultadoEstado.opciones.filter(op => !op.isPrimary);
            
            return (
              <Box sx={{ mt: 2, p: 2, backgroundColor: 'rgba(255,255,255,0.95)', borderRadius: 1, width: '100%' }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold', color: '#1976d2' }}>
                  {muestrasDetalleSeleccionadas.length} muestra(s) seleccionada(s)
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {opcionPrimaria && (
                    <Button
                      size="small"
                      variant="contained"
                      color={getEstadoButtonColor(opcionPrimaria.id)}
                      onClick={() => handleAccionMasiva(opcionPrimaria)}
                      startIcon={getEstadoIcon(opcionPrimaria.id)}
                      disabled={procesandoAccionMasiva || !tienePermiso('Acciones Toma Muestra')}
                    >
                      {opcionPrimaria.estado} ({muestrasDetalleSeleccionadas.length})
                    </Button>
                  )}
                  {opcionesSecundarias.map((opcion) => (
                    <Button
                      key={opcion.id}
                      size="small"
                      variant="outlined"
                      onClick={() => handleAccionMasiva(opcion)}
                      startIcon={getEstadoIcon(opcion.id)}
                      disabled={procesandoAccionMasiva || !tienePermiso('Acciones Toma Muestra')}
                    >
                      {opcion.estado} ({muestrasDetalleSeleccionadas.length})
                    </Button>
                  ))}
                  <Button
                    size="small"
                    variant="text"
                    color="secondary"
                    onClick={() => setMuestrasDetalleSeleccionadas([])}
                  >
                    Limpiar selección
                  </Button>
                </Box>
              </Box>
            );
          })()}
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {grupoSeleccionado && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="textSecondary">
                <strong>Módulo:</strong> {grupoSeleccionado.modulo || 'N/A'} | 
                <strong> Cantidad:</strong> {grupoSeleccionado.descripcionCantidad || 'N/A'}
              </Typography>
            </Box>
          )}
          
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={muestrasDetalleSeleccionadas.length > 0 && muestrasDetalleSeleccionadas.length < muestrasDetalle.length}
                      checked={muestrasDetalle.length > 0 && muestrasDetalleSeleccionadas.length === muestrasDetalle.length}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setMuestrasDetalleSeleccionadas(muestrasDetalle.map((_, idx) => idx));
                        } else {
                          setMuestrasDetalleSeleccionadas([]);
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>Análisis</TableCell>
                  <TableCell>Estado Actual</TableCell>
                  <TableCell>Cambiar Estado</TableCell>
                  <TableCell>Histórico</TableCell>
                  <TableCell>Usuario</TableCell>
                  <TableCell>Fecha</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {muestrasDetalle.map((examen, index) => (
                  <TableRow key={index}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={muestrasDetalleSeleccionadas.includes(index)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setMuestrasDetalleSeleccionadas([...muestrasDetalleSeleccionadas, index]);
                          } else {
                            setMuestrasDetalleSeleccionadas(muestrasDetalleSeleccionadas.filter(i => i !== index));
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>{examen.idMuestraXAnalisis || examen.id || index}</TableCell>
                    <TableCell>{examen.analisis || examen.nombreAnalisis || 'N/A'}</TableCell>
                    <TableCell>
                      <Chip 
                        label={getEstadoDescription(examen.estadoActual || examen.idEstado || 1)}
                        style={{ 
                          backgroundColor: getEstadoColor(examen.estadoActual || examen.idEstado || 1),
                          color: 'white',
                          fontSize: '0.75rem'
                        }}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <AccionesDropdown
                        estadoActual={examen.estadoActual || examen.idEstado || 1}
                        estadosDisponibles={estadosDisponibles}
                        onCambiarEstado={(nuevoEstado) => {
                          // Buscar el Ã­ndice real en muestrasEscaneadas
                          const realIndex = muestrasEscaneadas.findIndex(m => 
                            m.idMuestraXAnalisis === examen.idMuestraXAnalisis
                          );
                          if (realIndex !== -1) {
                            handleCambiarEstadoMuestra(realIndex, nuevoEstado);
                          }
                        }}
                        getEstadoIcon={getEstadoIcon}
                        getEstadoButtonColor={getEstadoButtonColor}
                        getSiguienteEstado={getSiguienteEstado}
                        puedeReactivarMuestraNoConforme={true}
                        enModalDetalle={true}
                        disabled={!tienePermiso('Acciones Toma Muestra')}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => handleAbrirHistorico(examen)}
                        color="primary"
                      >
                        <HistoryIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>{examen.usuarioToma || examen.ingresadoPor || 'N/A'}</TableCell>
                    <TableCell>
                      <Typography variant="caption">
                        {examen.fechaHoraToma || examen.fechaEscaneo 
                          ? new Date(examen.fechaHoraToma || examen.fechaEscaneo).toLocaleString()
                          : 'N/A'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCerrarDetalleModal} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de selección de Módulos/Análisis (UI Táctil Optimizada) */}
      <Dialog
        open={modalSeleccionAnalisisOpen}
        onClose={() => {
          setModalSeleccionAnalisisOpen(false);
          setModulosDisponiblesData([]);
          setAnalisisSeleccionados(new Set());
          setCodigoPendiente('');
          setCodigoBarra('');
          setTimeout(() => barcodeInputRef.current?.focus(), 100);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { 
            maxHeight: '85vh'
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: '#1976d2',
          color: 'white',
          py: 1.5
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <ScanIcon sx={{ fontSize: 28 }} />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Seleccione los Análisis a Verificar
                </Typography>
                <Typography variant="caption" sx={{ display: 'block', opacity: 0.9, fontSize: '0.75rem' }}>
                  Toque para seleccionar/deseleccionar
                </Typography>
              </Box>
            </Box>
            <IconButton
              onClick={() => {
                setModalSeleccionAnalisisOpen(false);
                setModulosDisponiblesData([]);
                setAnalisisSeleccionados(new Set());
                setCodigoPendiente('');
                setCodigoBarra('');
                setTimeout(() => barcodeInputRef.current?.focus(), 100);
              }}
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0, backgroundColor: '#fafafa' }}>
          <Box sx={{ p: 1 }}>
            {modulosDisponiblesData.map((modulo, moduloIndex) => {
              const examenes = modulo.examenes?.$values || modulo.examenes || [];
              const estaExpandido = gruposExpandidos.has(moduloIndex);
              const seleccionadosEnGrupo = examenes.filter(e => 
                analisisSeleccionados.has(`${moduloIndex}-${e.idMuestraXAnalisis || e.id}`)
              ).length;
              
              // Verificar si todos los anÃ¡lisis del grupo estÃ¡n verificados (estado 3)
              const todosVerificados = examenes.length > 0 && examenes.every(e => {
                const estadoActual = e.estadoActual || e.idEstado || 1;
                return estadoActual === 3;
              });
              
              return (
                <Box key={moduloIndex} sx={{ mb: 1 }}>
                  {/* Encabezado compacto del mÃ³dulo - clickeable para expandir/colapsar */}
                  <Box 
                    onClick={() => {
                      setGruposExpandidos(prev => {
                        const nuevos = new Set(prev);
                        if (nuevos.has(moduloIndex)) {
                          nuevos.delete(moduloIndex);
                        } else {
                          nuevos.add(moduloIndex);
                        }
                        return nuevos;
                      });
                    }}
                    sx={{ 
                      backgroundColor: todosVerificados ? '#4caf50' : '#1976d2',
                      color: 'white',
                      p: 1,
                      borderRadius: estaExpandido ? '4px 4px 0 0' : '4px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                      '&:hover': {
                        backgroundColor: todosVerificados ? '#43a047' : '#1565c0'
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <IconButton
                        size="small"
                        sx={{ color: 'white', p: 0.5 }}
                      >
                        {estaExpandido ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>
                          {modulo.modulo || 'N/A'}
                        </Typography>
                        <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
                          {modulo.descripcionMuestra || 'N/A'} - {modulo.descripcionCantidad || 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                      {seleccionadosEnGrupo > 0 && (
                        <Chip 
                          label={`${seleccionadosEnGrupo}/${examenes.length}`}
                          size="small"
                          sx={{ 
                            backgroundColor: '#4caf50',
                            color: 'white',
                            height: '20px',
                            fontSize: '0.7rem',
                            fontWeight: 'bold'
                          }}
                        />
                      )}
                      <Chip 
                        label={`${examenes.length}`}
                        size="small"
                        sx={{ 
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          color: 'white',
                          height: '20px',
                          fontSize: '0.7rem'
                        }}
                      />
                      <Button
                        size="small"
                        variant="text"
                        onClick={(e) => {
                          e.stopPropagation();
                          const nuevosSeleccionados = new Set(analisisSeleccionados);
                          examenes.forEach((examen) => {
                            const key = `${moduloIndex}-${examen.idMuestraXAnalisis || examen.id}`;
                            nuevosSeleccionados.add(key);
                          });
                          setAnalisisSeleccionados(nuevosSeleccionados);
                        }}
                        sx={{ 
                          color: 'white',
                          fontSize: '0.7rem',
                          minWidth: 'auto',
                          px: 1,
                          py: 0.5
                        }}
                      >
                        Todos
                      </Button>
                      <Button
                        size="small"
                        variant="text"
                        onClick={(e) => {
                          e.stopPropagation();
                          const nuevosSeleccionados = new Set(analisisSeleccionados);
                          examenes.forEach((examen) => {
                            const key = `${moduloIndex}-${examen.idMuestraXAnalisis || examen.id}`;
                            nuevosSeleccionados.delete(key);
                          });
                          setAnalisisSeleccionados(nuevosSeleccionados);
                        }}
                        sx={{ 
                          color: 'white',
                          fontSize: '0.7rem',
                          minWidth: 'auto',
                          px: 1,
                          py: 0.5
                        }}
                      >
                        Ninguno
                      </Button>
                    </Box>
                  </Box>

                  {/* Lista compacta de anÃ¡lisis - solo visible si estÃ¡ expandido */}
                  {estaExpandido && (
                  <Paper sx={{ borderRadius: '0 0 4px 4px', mb: 2 }}>
                    <Box>
                      {examenes.map((examen, examenIndex) => {
                        const key = `${moduloIndex}-${examen.idMuestraXAnalisis || examen.id}`;
                        const isSelected = analisisSeleccionados.has(key);
                        const estadoActual = examen.estadoActual || examen.idEstado || 1;
                        const nombreEstado = getEstadoDescription(estadoActual);
                        const colorEstado = getEstadoColor(estadoActual);
                        const esVerificado = estadoActual === 3;
                        
                        return (
                          <Box
                            key={examenIndex}
                            onClick={() => {
                              const nuevosSeleccionados = new Set(analisisSeleccionados);
                              if (isSelected) {
                                nuevosSeleccionados.delete(key);
                              } else {
                                nuevosSeleccionados.add(key);
                              }
                              setAnalisisSeleccionados(nuevosSeleccionados);
                            }}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              p: 1,
                              cursor: 'pointer',
                              backgroundColor: isSelected ? '#e8f5e9' : 'white',
                              borderLeft: isSelected ? '4px solid #4caf50' : '4px solid transparent',
                              borderBottom: '1px solid #e0e0e0',
                              transition: 'all 0.15s ease',
                              '&:hover': {
                                backgroundColor: isSelected ? '#c8e6c9' : '#f5f5f5'
                              },
                              '&:active': {
                                transform: 'scale(0.99)'
                              }
                            }}
                          >
                            <Checkbox
                              checked={isSelected}
                              sx={{ 
                                p: 0.5,
                                mr: 1,
                                '& .MuiSvgIcon-root': { fontSize: 24 }
                              }}
                              color="success"
                            />
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography 
                                variant="body2" 
                                sx={{ 
                                  fontWeight: isSelected ? 'bold' : 'medium',
                                  color: isSelected ? '#2e7d32' : '#000',
                                  fontSize: '0.875rem',
                                  lineHeight: 1.3,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {examen.analisis || examen.nombreAnalisis || 'AnÃ¡lisis'}
                              </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1 }}>
                              <Chip
                                label={nombreEstado}
                                size="small"
                                sx={{
                                  backgroundColor: colorEstado,
                                  color: 'white',
                                  fontSize: '0.65rem',
                                  height: '18px',
                                  fontWeight: 'bold'
                                }}
                              />
                              {esVerificado && (
                                <Tooltip title="Ya verificado - puede re-seleccionar" arrow>
                                  <WarningIcon sx={{ fontSize: 18, color: '#ff9800' }} />
                                </Tooltip>
                              )}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Paper>
                  )}
                </Box>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions sx={{ 
          p: 1.5, 
          backgroundColor: '#f5f5f5',
          borderTop: '2px solid #e0e0e0',
          justifyContent: 'space-between'
        }}>
          <Chip 
            label={`Seleccionados: ${analisisSeleccionados.size}`}
            color="primary"
            size="small"
            sx={{ fontWeight: 'bold' }}
          />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              onClick={() => {
                setModalSeleccionAnalisisOpen(false);
                setModulosDisponiblesData([]);
                setAnalisisSeleccionados(new Set());
                setCodigoPendiente('');
                setCodigoBarra('');
                setTimeout(() => barcodeInputRef.current?.focus(), 100);
              }}
              color="secondary"
              variant="outlined"
              size="medium"
            >
              Cancelar
            </Button>
            <Button 
              onClick={async () => {
                if (analisisSeleccionados.size === 0) {
                  Swal.fire('Atención', 'Debe seleccionar al menos un análisis', 'warning');
                  return;
                }
                
                setLoading(true);
                
                // Agrupar anÃ¡lisis por módulo + tipo de muestra + cantidad
                // Los que tengan la misma combinación van en una fila, los diferentes en filas separadas
                const gruposPorCombinacion = new Map();
                
                for (const key of analisisSeleccionados) {
                  const [moduloIndex, idMuestraXAnalisis] = key.split('-');
                  const modulo = modulosDisponiblesData[parseInt(moduloIndex)];
                  const examenes = modulo.examenes?.$values || modulo.examenes || [];
                  const examen = examenes.find(e => (e.idMuestraXAnalisis || e.id).toString() === idMuestraXAnalisis);
                  
                  if (examen && modulo) {
                    // Crear clave Ãºnica: mÃ³dulo + tipo de muestra + cantidad
                    const claveGrupo = `${modulo.modulo}_${modulo.descripcionMuestra}_${modulo.descripcionCantidad}`;
                    
                    // Asegurar que el examen tenga estadoActual
                    const examenConEstado = {
                      ...examen,
                      estadoActual: examen.estadoActual || examen.idEstado || 1
                    };
                    
                    if (!gruposPorCombinacion.has(claveGrupo)) {
                      gruposPorCombinacion.set(claveGrupo, {
                        modulo: modulo,
                        examenes: []
                      });
                    }
                    
                    gruposPorCombinacion.get(claveGrupo).examenes.push(examenConEstado);
                  }
                }
                
                // Procesar cada grupo como una fila separada
                for (const [claveGrupo, grupo] of gruposPorCombinacion) {
                  const { modulo, examenes: examenesGrupo } = grupo;
                  
                  const dataAgrupada = {
                    ...modulo,
                    idMuestraXAnalisis: examenesGrupo[0].idMuestraXAnalisis || examenesGrupo[0].id,
                    analisis: examenesGrupo.map(e => e.analisis || e.nombreAnalisis).join(', '),
                    nombreAnalisis: examenesGrupo.map(e => e.analisis || e.nombreAnalisis).join(', '),
                    estadoActual: examenesGrupo[0].estadoActual,
                    examenes: examenesGrupo,
                    cantidadExamenes: examenesGrupo.length
                  };
                  
                  // Procesar cada grupo (mÃ³dulo + muestra + cantidad) como una fila
                  await procesarMuestraEscaneada(dataAgrupada, codigoPendiente, true);
                }
                
                setLoading(false);
                setModalSeleccionAnalisisOpen(false);
                setModulosDisponiblesData([]);
                setAnalisisSeleccionados(new Set());
                setCodigoPendiente('');
                setCodigoBarra('');
                
                Swal.fire({
                  title: 'Análisis Procesados',
                  text: gruposPorCombinacion.size === 1 
                    ? `Se procesaron ${analisisSeleccionados.size} análisis en 1 fila`
                    : `Se procesaron ${analisisSeleccionados.size} análisis en ${gruposPorCombinacion.size} filas`,
                  icon: 'success',
                  timer: 2500,
                  showConfirmButton: false
                });
                
                setTimeout(() => barcodeInputRef.current?.focus(), 100);
              }}
              color="primary"
              variant="contained"
              disabled={analisisSeleccionados.size === 0 || loading}
              startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <CheckCircle />}
              size="medium"
              sx={{ 
                fontWeight: 'bold'
              }}
            >
              {loading ? 'Procesando...' : `Procesar (${analisisSeleccionados.size})`}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Modal de histÃ³rico de estados */}
      <Dialog
        open={modalHistoricoOpen}
        onClose={() => setModalHistoricoOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          backgroundColor: '#1976d2',
          color: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <HistoryIcon />
            <Typography variant="h6">
              Histórico de Estados - {grupoSeleccionado?.descripcionMuestra || 'Muestra'}
            </Typography>
          </Box>
          <IconButton
            onClick={() => setModalHistoricoOpen(false)}
            sx={{ color: 'white' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {grupoSeleccionado && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="textSecondary">
                <strong>Muestra:</strong> {grupoSeleccionado.descripcionMuestra || 'N/A'} | 
                <strong> Módulo:</strong> {grupoSeleccionado.modulo || 'N/A'}
              </Typography>
            </Box>
          )}
          
          {grupoSeleccionado && grupoSeleccionado.historico && grupoSeleccionado.historico.length > 0 ? (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Fecha Cambio</TableCell>
                    <TableCell>Estado Anterior</TableCell>
                    <TableCell>Estado Nuevo</TableCell>
                    <TableCell>Usuario</TableCell>
                    <TableCell>Comentario</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {grupoSeleccionado.historico.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography variant="caption">
                          {item.fecha_cambio_estado 
                            ? new Date(item.fecha_cambio_estado).toLocaleString('es-ES', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit'
                              })
                            : 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {item.estadoAnterior || item.estado_anterior ? (
                          <Chip 
                            label={item.estadoAnterior || item.estado_anterior}
                            size="small"
                            variant="outlined"
                          />
                        ) : (
                          <Typography variant="caption" color="textSecondary">N/A</Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        {item.estadoNuevo || item.estado_nuevo ? (
                          <Chip 
                            label={item.estadoNuevo || item.estado_nuevo}
                            size="small"
                            color="primary"
                          />
                        ) : (
                          <Typography variant="caption" color="textSecondary">N/A</Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography variant="caption">
                          {item.cambiado_por || item.usuario || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography 
                          variant="caption" 
                          sx={{ 
                            maxWidth: '300px',
                            display: 'block',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word'
                          }}
                        >
                          {item.comentario || 'Sin comentario'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Alert severity="info">
              No hay histórico de cambios de estado para esta muestra
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalHistoricoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TomaMuestraPorCodigo;
